webpackJsonp(["app"],{

/***/ "+bsQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-c1.cf85c5eb9acce5553a85122616f8f7f3.png";

/***/ }),

/***/ "/BPU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-b3.f56ee08f09215c9501370c94a97d5da1.png";

/***/ }),

/***/ "1Tjk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-d5.93f0c9556e78c0b2b5ab5a7bb293e22c.png";

/***/ }),

/***/ "2+Yo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__("M4fF");
var AdjacentHint = (function () {
    function AdjacentHint(row1, variant1, row2, variant2) {
        this.row1 = row1;
        this.variant1 = variant1;
        this.row2 = row2;
        this.variant2 = variant2;
    }
    AdjacentHint.prototype.applyTo = function (board) {
        var changed = false;
        var applyToCol = function (col, thisRow, thisVariant, adjRow, adjVariant) {
            var hasLeft = col >= 1 ? board.isPossible(adjRow, col - 1, adjVariant) : false;
            var hasRight = col < board.cols - 1 ? board.isPossible(adjRow, col + 1, adjVariant) : false;
            if (!hasLeft && !hasRight && board.isPossible(thisRow, col, thisVariant)) {
                board.remove(thisRow, col, thisVariant);
                changed = true;
            }
        };
        for (var col = 0; col < board.cols; col++) {
            applyToCol(col, this.row1, this.variant1, this.row2, this.variant2);
            applyToCol(col, this.row2, this.variant2, this.row1, this.variant1);
        }
        if (changed)
            this.applyTo(board);
        return changed;
    };
    AdjacentHint.prototype.getType = function () {
        return 1 /* Horizontal */;
    };
    return AdjacentHint;
}());
exports.AdjacentHint = AdjacentHint;
var AdjacentHintFactory = (function () {
    function AdjacentHintFactory() {
    }
    AdjacentHintFactory.prototype.supports = function (options) {
        return options.rows >= 1 && options.cols >= 2;
    };
    AdjacentHintFactory.prototype.random = function (board) {
        var row1 = _.random(0, board.rows - 1);
        var col1 = _.random(0, board.cols - 1);
        var row2 = _.random(0, board.rows - 1);
        var colDelta;
        if (col1 == 0)
            colDelta = 1;
        else if (col1 == board.cols - 1)
            colDelta = -1;
        else
            colDelta = _.random(0, 1) == 1 ? 1 : -1;
        var col2 = col1 + colDelta;
        return new AdjacentHint(row1, board.get(row1, col1), row2, board.get(row2, col2));
    };
    return AdjacentHintFactory;
}());
exports.AdjacentHintFactory = AdjacentHintFactory;


/***/ }),

/***/ "20Ho":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-c6.3a75bba0385dcc7f6e7074d7873ff81e.png";

/***/ }),

/***/ "27d+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-b1.376d5df50dd14a86919d705382c89060.png";

/***/ }),

/***/ "2JYO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "32Ag":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__("M4fF");
var Timer = (function () {
    function Timer() {
        this.reset();
    }
    Timer.prototype.start = function () {
        if (this.startTime === null)
            this.startTime = _.now();
    };
    Timer.prototype.pause = function () {
        var runningTime = this.getRunningTime();
        if (runningTime !== null) {
            this.totalTime += runningTime;
            this.startTime = null;
        }
    };
    Timer.prototype.getRunningTime = function () {
        return this.startTime !== null ? _.now() - this.startTime : null;
    };
    Timer.prototype.getTotalTime = function () {
        return this.totalTime + (this.getRunningTime() || 0);
    };
    Timer.prototype.reset = function () {
        this.totalTime = 0;
        this.startTime = null;
    };
    return Timer;
}());
exports.Timer = Timer;


/***/ }),

/***/ "4I4A":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-a3.2f39989763b3636f69b02ba2b53fbe44.png";

/***/ }),

/***/ "4mO9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var db_1 = __webpack_require__("ATbC");
var Wasm;
(function (Wasm) {
    function getCached(url) {
        return db_1.db.wasm.get(url, function (wasmItem) {
            console.log("wasm from db:");
            console.debug(wasmItem);
            return wasmItem !== undefined ? wasmItem.module : undefined;
        });
    }
    Wasm.getCached = getCached;
    function cache(url, module) {
        var wasmItem = {
            url: url,
            module: module
        };
        console.log("wasm to db:");
        console.debug(wasmItem);
        db_1.db.transaction("rw", db_1.db.wasm, function () {
            return db_1.db.wasm.clear().then(function () {
                return db_1.db.wasm.put(wasmItem);
            });
        }).then(function () { return console.log("wasm cached"); });
    }
    Wasm.cache = cache;
})(Wasm = exports.Wasm || (exports.Wasm = {}));


/***/ }),

/***/ "5AqA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__("M4fF");
function formatDuration(diffMs) {
    var diffSec = diffMs / 1000;
    var sec = Math.floor(diffSec) % 60;
    var min = Math.floor(diffSec / 60) % 60;
    var hr = Math.floor(diffSec / 60 / 60);
    return _.padStart(hr.toString(), 2, "0") + ":" + _.padStart(min.toString(), 2, "0") + ":" + _.padStart(sec.toString(), 2, "0");
    /*let ms = Math.floor(diffMs % 1000);
    return `${_.padStart(hr.toString(), 2, "0")}:${_.padStart(min.toString(), 2, "0")}:${_.padStart(sec.toString(), 2, "0")}.${_.padStart(ms.toString(), 3, "0")}`;*/
}
exports.formatDuration = formatDuration;


/***/ }),

/***/ "6RO1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var _ = __webpack_require__("M4fF");
var RandomHint_1 = __webpack_require__("gYeE");
var HintsGenerator_1 = __webpack_require__("S+P+");
var ExtraHintsGenerator = (function (_super) {
    tslib_1.__extends(ExtraHintsGenerator, _super);
    function ExtraHintsGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExtraHintsGenerator.prototype.supports = function (options) {
        return _super.prototype.supports.call(this, options) && ExtraHintsGenerator.hintFactory.supports(options);
    };
    ExtraHintsGenerator.prototype.generate = function (options, board) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var hints;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delegate.generate(options, board)];
                    case 1:
                        hints = _a.sent();
                        return [2 /*return*/, ExtraHintsGenerator.generateExtraHints(options, board, hints)];
                }
            });
        });
    };
    ExtraHintsGenerator.generateExtraHints = function (options, board, hints) {
        hints = _.clone(hints);
        var extraHints = Math.round((options.extraHintsPercent / 100) * hints.length);
        console.debug("Adding extra hints: " + extraHints);
        for (var i = 0; i < extraHints; i++) {
            var hint = ExtraHintsGenerator.hintFactory.random(board);
            hints.push(hint);
        }
        return hints;
    };
    ExtraHintsGenerator.hintFactory = new RandomHint_1.RandomHintFactory();
    return ExtraHintsGenerator;
}(HintsGenerator_1.DelegateHintsGenerator));
exports.ExtraHintsGenerator = ExtraHintsGenerator;


/***/ }),

/***/ "6b+j":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-b2.1e0362bc91fe36a746482f52eea6cd78.png";

/***/ }),

/***/ "7PiI":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./icons/original/hint-adjacent.png": "Qj03",
	"./icons/original/hint-between.png": "IJZH",
	"./icons/original/hint-direction.png": "Op0r",
	"./icons/original/hint-tile.png": "qwlA",
	"./icons/original/large/large-a1.png": "QP0S",
	"./icons/original/large/large-a2.png": "NhLW",
	"./icons/original/large/large-a3.png": "4I4A",
	"./icons/original/large/large-a4.png": "ytF8",
	"./icons/original/large/large-a5.png": "TeOI",
	"./icons/original/large/large-a6.png": "N7YA",
	"./icons/original/large/large-b1.png": "UBU4",
	"./icons/original/large/large-b2.png": "w35o",
	"./icons/original/large/large-b3.png": "/BPU",
	"./icons/original/large/large-b4.png": "BRDO",
	"./icons/original/large/large-b5.png": "YKaq",
	"./icons/original/large/large-b6.png": "mPGt",
	"./icons/original/large/large-c1.png": "+bsQ",
	"./icons/original/large/large-c2.png": "oXIE",
	"./icons/original/large/large-c3.png": "XjqR",
	"./icons/original/large/large-c4.png": "mGEC",
	"./icons/original/large/large-c5.png": "rxGk",
	"./icons/original/large/large-c6.png": "oJmq",
	"./icons/original/large/large-d1.png": "cgSM",
	"./icons/original/large/large-d2.png": "oD70",
	"./icons/original/large/large-d3.png": "PWPq",
	"./icons/original/large/large-d4.png": "D3DT",
	"./icons/original/large/large-d5.png": "1Tjk",
	"./icons/original/large/large-d6.png": "q9gS",
	"./icons/original/large/large-e1.png": "ZvN9",
	"./icons/original/large/large-e2.png": "dcOB",
	"./icons/original/large/large-e3.png": "91Mv",
	"./icons/original/large/large-e4.png": "SAo3",
	"./icons/original/large/large-e5.png": "hli+",
	"./icons/original/large/large-e6.png": "YFuY",
	"./icons/original/large/large-f1.png": "ZNit",
	"./icons/original/large/large-f2.png": "zU+P",
	"./icons/original/large/large-f3.png": "gVWB",
	"./icons/original/large/large-f4.png": "yFfv",
	"./icons/original/large/large-f5.png": "t+UZ",
	"./icons/original/large/large-f6.png": "dSmd",
	"./icons/original/small/small-a1.png": "qpPT",
	"./icons/original/small/small-a2.png": "nVYH",
	"./icons/original/small/small-a3.png": "x5BK",
	"./icons/original/small/small-a4.png": "Htyr",
	"./icons/original/small/small-a5.png": "uVvn",
	"./icons/original/small/small-a6.png": "pqg3",
	"./icons/original/small/small-b1.png": "27d+",
	"./icons/original/small/small-b2.png": "6b+j",
	"./icons/original/small/small-b3.png": "RUP8",
	"./icons/original/small/small-b4.png": "romA",
	"./icons/original/small/small-b5.png": "fZOX",
	"./icons/original/small/small-b6.png": "Z31m",
	"./icons/original/small/small-c1.png": "kbZK",
	"./icons/original/small/small-c2.png": "gBE2",
	"./icons/original/small/small-c3.png": "mcFw",
	"./icons/original/small/small-c4.png": "90E6",
	"./icons/original/small/small-c5.png": "AQov",
	"./icons/original/small/small-c6.png": "20Ho",
	"./icons/original/small/small-d1.png": "C7Cf",
	"./icons/original/small/small-d2.png": "xDob",
	"./icons/original/small/small-d3.png": "Dvz/",
	"./icons/original/small/small-d4.png": "iXl1",
	"./icons/original/small/small-d5.png": "d6hy",
	"./icons/original/small/small-d6.png": "hFVX",
	"./icons/original/small/small-e1.png": "SCQN",
	"./icons/original/small/small-e2.png": "uLm8",
	"./icons/original/small/small-e3.png": "E9CV",
	"./icons/original/small/small-e4.png": "XnXw",
	"./icons/original/small/small-e5.png": "P2+R",
	"./icons/original/small/small-e6.png": "lgdU",
	"./icons/original/small/small-f1.png": "voAe",
	"./icons/original/small/small-f2.png": "xFS2",
	"./icons/original/small/small-f3.png": "Hoba",
	"./icons/original/small/small-f4.png": "yNUn",
	"./icons/original/small/small-f5.png": "MjYr",
	"./icons/original/small/small-f6.png": "QfaF",
	"./icons/original/tile.png": "FslU",
	"./rain-light.png": "8OvN",
	"./rain.png": "kCQN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7PiI";

/***/ }),

/***/ "7Pv6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var dexie_1 = __webpack_require__("dlzC");
var EinsteinDatabase = (function (_super) {
    tslib_1.__extends(EinsteinDatabase, _super);
    function EinsteinDatabase() {
        var _this = _super.call(this, "EinsteinDatabase") || this;
        _this.version(1).stores({
            times: "++, [rows+cols+extraHintsPercent]"
        });
        _this.version(2).stores({
            config: "key"
        });
        _this.version(3).stores({
            counts: "[rows+cols+extraHintsPercent]"
        });
        /*
        counts has puzzle options as primary key.
        Dexie can't upgrade primary key changes automatically: https://github.com/dfahlander/Dexie.js/issues/88#issuecomment-285384576
        Must use temporary table to recreate with additional auto-increment primary key.
        Must use separate versions for deletion for some reason: https://github.com/dfahlander/Dexie.js/issues/105#issuecomment-405670992
         */
        _this.version(4).stores({
            countsTmp: "[rows+cols+extraHintsPercent]"
        }).upgrade(function (tx) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var countsItems;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, tx.table("counts").toArray()];
                    case 1:
                        countsItems = _a.sent();
                        return [4 /*yield*/, tx.table("countsTmp").bulkAdd(countsItems)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        _this.version(5).stores({
            counts: null
        });
        _this.version(6).stores({
            counts: "++id, [rows+cols+extraHintsPercent]"
        }).upgrade(function (tx) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var countsItemsTmp;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, tx.table("countsTmp").toArray()];
                    case 1:
                        countsItemsTmp = _a.sent();
                        return [4 /*yield*/, tx.table("counts").bulkAdd(countsItemsTmp)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        _this.version(7).stores({
            countsTmp: null
        });
        _this.version(8).stores({
            times: "++, [rows+cols+extraHintsPercent+difficulty]",
            counts: "++id, [rows+cols+extraHintsPercent+difficulty]"
        }).upgrade(function (tx) {
            return dexie_1.default.Promise.all([
                tx.table("times").toCollection().modify({
                    difficulty: "normal"
                }),
                tx.table("config").update("options", {
                    "value.difficulty": "normal" // actual object is in value
                }),
                tx.table("counts").toCollection().modify({
                    difficulty: "normal"
                }),
            ]);
        });
        _this.version(9).stores({
            wasm: "url"
        });
        return _this;
    }
    return EinsteinDatabase;
}(dexie_1.default));
exports.EinsteinDatabase = EinsteinDatabase;


/***/ }),

/***/ "7Stf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var _ = __webpack_require__("M4fF");
var db_1 = __webpack_require__("ATbC");
var Counts;
(function (Counts) {
    function get(options) {
        return db_1.db.counts.get(tslib_1.__assign({}, options), function (countsItem) {
            if (countsItem === undefined) {
                var defaultItem = tslib_1.__assign({}, options, { solved: 0, solvedCheated: 0, over: 0 }); // extracted to have explicit type annotation
                return defaultItem;
            }
            else
                return countsItem;
        });
    }
    Counts.get = get;
    function getTopCounts() {
        return db_1.db.counts.toArray().then(function (countsItems) {
            return _.orderBy(countsItems, function (countsItem) {
                return countsItem.solved + countsItem.solvedCheated + countsItem.over;
            }, ["desc"]);
        });
    }
    Counts.getTopCounts = getTopCounts;
    function increase(options, count) {
        return db_1.db.transaction("rw", db_1.db.counts, function () {
            return get(options).then(function (countsItem) {
                var newCountsItem = _.merge(countsItem, (_a = {},
                    _a[count] = countsItem[count] + 1,
                    _a));
                return db_1.db.counts.put(newCountsItem);
                var _a;
            });
        });
    }
    Counts.increase = increase;
})(Counts = exports.Counts || (exports.Counts = {}));


/***/ }),

/***/ "7YgM":
/***/ (function(module, exports) {

module.exports = {"name":"einstein","version":"2.0.2","description":"Einstein Puzzle 2.0 by Flowix Games ported to the web","author":"Simmo Saan","keywords":["typescript","webpack","preact","lodash","game","puzzle-game","web"],"repository":{"type":"git","url":"git+https://github.com/sim642/einstein-js.git"},"bugs":{"url":"https://github.com/sim642/einstein-js/issues"},"homepage":"https://einstein.sim642.eu","scripts":{"build:dev":"webpack --env=dev --progress --profile --colors","build:prod":"webpack --env=prod --progress --profile --colors","coverage":"nyc --reporter=lcov --reporter=text npm test","deploy":"git push -f origin `git subtree split --prefix dist 2> /dev/null`:gh-pages","test":"mocha-webpack","watch:dev":"webpack --env=dev --progress --profile --colors --watch","watch:test":"mocha-webpack --watch"},"dependencies":{"classnames":"^2.2.5","dexie":"^3.0.0-alpha.3","lodash":"^4.17.10","preact":"^8.2.1","tslib":"^1.9.3","z3em":"^0.0.5"},"devDependencies":{"@types/chai":"^4.1.4","@types/lodash":"^4.14.112","@types/mocha":"^5.2.5","@types/webassembly-js-api":"0.0.1","@types/webpack-env":"^1.13.0","autoprefixer":"^7.1.2","chai":"^4.1.2","chi-squared":"^1.1.0","chunk-manifest-webpack-plugin":"1.1.0","clean-webpack-plugin":"^0.1.16","copy-webpack-plugin":"^4.0.1","css-loader":"^0.28.4","css-mqpacker":"^6.0.1","extract-text-webpack-plugin":"^3.0.0","file-loader":"^0.11.2","html-webpack-plugin":"^2.29.0","istanbul-instrumenter-loader":"^3.0.0","less":"^2.7.2","less-loader":"^4.0.4","mocha":"^5.2.0","mocha-webpack":"^1.1.0","nyc":"^12.0.2","offline-plugin":"^4.8.1","postcss-loader":"^2.0.6","preload-webpack-plugin":"^2.3.0","style-loader":"^0.18.2","ts-loader":"^2.2.0","typescript":"^2.4.2","webpack":"^3.0.0","webpack-chunk-hash":"^0.4.0","webpack-merge":"^4.1.0","webpack-node-externals":"^1.6.0"},"nyc":{"extension":[".tsx",".ts",".jsx"],"instrument":false,"sourceMap":false}}

/***/ }),

/***/ "8OvN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./rain-light.272fb79b7c99a89b9891f2d596aabecc.png";

/***/ }),

/***/ "90E6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-c4.bc367c0d574d1037f7983b61b94776bf.png";

/***/ }),

/***/ "91Mv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-e3.24b0bdf46ccfa5fae6d324e4b08c9a31.png";

/***/ }),

/***/ "99qC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9OCd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__("M4fF");
function mean(arr) {
    return _.sum(arr) / arr.length;
}
exports.mean = mean;
function variance(arr, knownMean) {
    if (knownMean === void 0) { knownMean = mean(arr); }
    return _.sumBy(arr, function (x) { return Math.pow(x - knownMean, 2); }) / arr.length;
}
exports.variance = variance;
function stdDev(arr, knownMean) {
    if (knownMean === void 0) { knownMean = mean(arr); }
    return Math.sqrt(variance(arr, knownMean));
}
exports.stdDev = stdDev;


/***/ }),

/***/ "AQov":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-c5.9254afe6e7940800db50da758cb752df.png";

/***/ }),

/***/ "ATbC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EinsteinDatabase_1 = __webpack_require__("7Pv6");
exports.db = new EinsteinDatabase_1.EinsteinDatabase();


/***/ }),

/***/ "Agl8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MessageUnloadListener = (function () {
    function MessageUnloadListener(callback) {
        var _this = this;
        this.callback = callback;
        this.onBeforeUnload = function (e) {
            var message = _this.callback();
            if (message !== null)
                return e.returnValue = message;
            else
                return undefined;
        };
    }
    MessageUnloadListener.prototype.add = function () {
        window.addEventListener("beforeunload", this.onBeforeUnload);
    };
    MessageUnloadListener.prototype.remove = function () {
        window.removeEventListener("beforeunload", this.onBeforeUnload);
    };
    return MessageUnloadListener;
}());
exports.MessageUnloadListener = MessageUnloadListener;


/***/ }),

/***/ "BRDO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-b4.cde289fd73095da992ec76470fcaf001.png";

/***/ }),

/***/ "C7Cf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-d1.4623124355805891864ed2e7f2bec09a.png";

/***/ }),

/***/ "CBd9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var _ = __webpack_require__("M4fF");
var Board_1 = __webpack_require__("bWR4");
var MultiBoard = (function (_super) {
    tslib_1.__extends(MultiBoard, _super);
    function MultiBoard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultiBoard.full = function (options) {
        return new MultiBoard(_.times(options.rows, function (row) { return _.times(options.cols, function (col) { return _.times(options.cols, _.constant(true)); }); }), options);
    };
    MultiBoard.numberVariants = function (table, options) {
        return new MultiBoard(_.map(table, function (rowCells) { return _.map(rowCells, function (cell) {
            var variants = _.times(rowCells.length, _.constant(false));
            for (var _i = 0, cell_1 = cell; _i < cell_1.length; _i++) {
                var numberVariant = cell_1[_i];
                variants[numberVariant] = true;
            }
            return variants;
        }); }), options);
    };
    MultiBoard.prototype.remove = function (row, col, variant) {
        if (this.get(row, col)[variant]) {
            this.get(row, col)[variant] = false;
            this.pruneSingles(row);
        }
    };
    MultiBoard.prototype.set = function (row, col, variant) {
        for (var variant_1 = 0; variant_1 < this.variants; variant_1++)
            this.get(row, col)[variant_1] = false;
        for (var col_1 = 0; col_1 < this.cols; col_1++)
            this.get(row, col_1)[variant] = false;
        this.get(row, col)[variant] = true;
        this.pruneSingles(row);
    };
    MultiBoard.prototype.isPossible = function (row, col, variant) {
        return this.get(row, col)[variant];
    };
    MultiBoard.prototype.count = function (row, col) {
        return _.sumBy(this.get(row, col), function (variant) { return variant ? 1 : 0; });
    };
    MultiBoard.prototype.isSingle = function (row, col) {
        return this.count(row, col) == 1;
    };
    MultiBoard.prototype.getSingle = function (row, col) {
        return _.findIndex(this.get(row, col));
    };
    MultiBoard.prototype.pruneSingles = function (row) {
        var colCnt = _.times(this.cols, _.constant(0));
        var variantCnt = _.times(this.variants, _.constant(0));
        var colVariant = _.times(this.cols, _.constant(0));
        var variantCol = _.times(this.variants, _.constant(0));
        for (var col = 0; col < this.cols; col++) {
            for (var variant = 0; variant < this.variants; variant++) {
                if (this.get(row, col)[variant]) {
                    colCnt[col]++;
                    variantCnt[variant]++;
                    colVariant[col] = variant;
                    variantCol[variant] = col;
                }
            }
        }
        var changed = false;
        for (var col = 0; col < this.cols; col++) {
            if (colCnt[col] == 1 && variantCnt[colVariant[col]] != 1) {
                var variant = colVariant[col];
                for (var col2 = 0; col2 < this.cols; col2++) {
                    if (col2 != col)
                        this.get(row, col2)[variant] = false;
                }
                changed = true;
            }
        }
        for (var variant = 0; variant < this.variants; variant++) {
            if (variantCnt[variant] == 1 && colCnt[variantCol[variant]] != 1) {
                var col = variantCol[variant];
                for (var variant2 = 0; variant2 < this.variants; variant2++) {
                    if (variant2 != variant)
                        this.get(row, col)[variant2] = false;
                }
                changed = true;
            }
        }
        if (changed)
            this.pruneSingles(row);
    };
    MultiBoard.prototype.applyHint = function (hint) {
        return hint.applyTo(this);
    };
    MultiBoard.prototype.applyHints = function (hints) {
        var changed = false;
        var changed2;
        do {
            changed2 = false;
            for (var _i = 0, hints_1 = hints; _i < hints_1.length; _i++) {
                var hint = hints_1[_i];
                if (this.applyHint(hint))
                    changed = changed2 = true;
            }
        } while (changed2);
        return changed;
    };
    MultiBoard.prototype.applySingleHint = function (hints) {
        for (var _i = 0, hints_2 = hints; _i < hints_2.length; _i++) {
            var hint = hints_2[_i];
            if (this.applyHint(hint))
                return true;
        }
        return false;
    };
    MultiBoard.prototype.isSolved = function (singleBoard) {
        return this.isSingleBoard() && this.contains(singleBoard);
    };
    MultiBoard.prototype.isSingleBoard = function () {
        for (var row = 0; row < this.rows; row++) {
            for (var col = 0; col < this.cols; col++) {
                if (!this.isSingle(row, col))
                    return false;
            }
        }
        return true;
    };
    MultiBoard.prototype.contains = function (singleBoard) {
        for (var row = 0; row < this.rows; row++) {
            for (var col = 0; col < this.cols; col++) {
                if (!this.isPossible(row, col, singleBoard.get(row, col)))
                    return false;
            }
        }
        return true;
    };
    MultiBoard.prototype.applySingleBoard = function (singleBoard) {
        if (this.isSolved(singleBoard))
            return false;
        else {
            for (var row = 0; row < this.rows; row++) {
                for (var col = 0; col < this.cols; col++) {
                    var singleVariant = singleBoard.get(row, col);
                    for (var variant = 0; variant < this.variants; variant++)
                        this.get(row, col)[variant] = variant == singleVariant;
                }
            }
            return true;
        }
    };
    return MultiBoard;
}(Board_1.Board));
exports.MultiBoard = MultiBoard;


/***/ }),

/***/ "D3DT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-d4.08e21c2cf4f787a7913cc84db58777ec.png";

/***/ }),

/***/ "DAXx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__("M4fF");
var BetweenHint = (function () {
    function BetweenHint(row1, variant1, rowMiddle, variantMiddle, row2, variant2) {
        this.row1 = row1;
        this.variant1 = variant1;
        this.rowMiddle = rowMiddle;
        this.variantMiddle = variantMiddle;
        this.row2 = row2;
        this.variant2 = variant2;
    }
    BetweenHint.prototype.applyTo = function (board) {
        var changed = false;
        if (board.isPossible(this.rowMiddle, 0, this.variantMiddle)) {
            board.remove(this.rowMiddle, 0, this.variantMiddle);
            changed = true;
        }
        if (board.isPossible(this.rowMiddle, board.cols - 1, this.variantMiddle)) {
            board.remove(this.rowMiddle, board.cols - 1, this.variantMiddle);
            changed = true;
        }
        var changed2;
        do {
            changed2 = false;
            for (var col = 1; col < board.cols - 1; col++) {
                if (board.isPossible(this.rowMiddle, col, this.variantMiddle) &&
                    !(board.isPossible(this.row1, col - 1, this.variant1) && board.isPossible(this.row2, col + 1, this.variant2) ||
                        board.isPossible(this.row2, col - 1, this.variant2) && board.isPossible(this.row1, col + 1, this.variant1))) {
                    board.remove(this.rowMiddle, col, this.variantMiddle);
                    changed2 = true;
                }
            }
            for (var col = 0; col < board.cols; col++) {
                if (board.isPossible(this.row1, col, this.variant1)) {
                    var leftPossible = col >= 2 ? board.isPossible(this.rowMiddle, col - 1, this.variantMiddle) && board.isPossible(this.row2, col - 2, this.variant2) : false;
                    var rightPossible = col < board.cols - 2 ? board.isPossible(this.rowMiddle, col + 1, this.variantMiddle) && board.isPossible(this.row2, col + 2, this.variant2) : false;
                    if (!leftPossible && !rightPossible) {
                        board.remove(this.row1, col, this.variant1);
                        changed2 = true;
                    }
                }
                if (board.isPossible(this.row2, col, this.variant2)) {
                    var leftPossible = col >= 2 ? board.isPossible(this.rowMiddle, col - 1, this.variantMiddle) && board.isPossible(this.row1, col - 2, this.variant1) : false;
                    var rightPossible = col < board.cols - 2 ? board.isPossible(this.rowMiddle, col + 1, this.variantMiddle) && board.isPossible(this.row1, col + 2, this.variant1) : false;
                    if (!leftPossible && !rightPossible) {
                        board.remove(this.row2, col, this.variant2);
                        changed2 = true;
                    }
                }
            }
            if (changed2)
                changed = true;
        } while (changed2);
        return changed;
    };
    BetweenHint.prototype.getType = function () {
        return 1 /* Horizontal */;
    };
    return BetweenHint;
}());
exports.BetweenHint = BetweenHint;
var BetweenHintFactory = (function () {
    function BetweenHintFactory() {
    }
    BetweenHintFactory.prototype.supports = function (options) {
        return options.rows >= 1 && options.cols >= 3;
    };
    BetweenHintFactory.prototype.random = function (board) {
        var row1 = _.random(0, board.rows - 1);
        var rowMiddle = _.random(0, board.rows - 1);
        var colMiddle = _.random(1, board.cols - 2);
        var row2 = _.random(0, board.rows - 1);
        var colDelta = _.random(0, 1) == 1 ? 1 : -1;
        var col1 = colMiddle + colDelta;
        var col2 = colMiddle - colDelta;
        return new BetweenHint(row1, board.get(row1, col1), rowMiddle, board.get(rowMiddle, colMiddle), row2, board.get(row2, col2));
    };
    return BetweenHintFactory;
}());
exports.BetweenHintFactory = BetweenHintFactory;


/***/ }),

/***/ "Dvz/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-d3.402ab38c15f0b6e6d5bf8c21c1966cac.png";

/***/ }),

/***/ "E9CV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-e3.158bc24007fc557a4756dcaaf638f81c.png";

/***/ }),

/***/ "FslU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/tile.3631d1df5b147c00992f293ab1246a12.png";

/***/ }),

/***/ "GgXB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DifficultyHintsGenerator = (function () {
    function DifficultyHintsGenerator(generators) {
        this.generators = generators;
    }
    DifficultyHintsGenerator.prototype.supports = function (options) {
        return this.generators[options.difficulty].supports(options);
    };
    DifficultyHintsGenerator.prototype.generate = function (options, board) {
        return this.generators[options.difficulty].generate(options, board);
    };
    return DifficultyHintsGenerator;
}());
exports.DifficultyHintsGenerator = DifficultyHintsGenerator;


/***/ }),

/***/ "HZR3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__("M4fF");
var db_1 = __webpack_require__("ATbC");
var Config;
(function (Config) {
    function getKey(key) {
        return db_1.db.config.get(key, function (configItem) { return configItem !== undefined ? configItem.value : undefined; });
    }
    Config.getKey = getKey;
    function get() {
        return db_1.db.config.toArray(function (configItems) {
            return _.fromPairs(_.map(configItems, function (configItem) { return [configItem.key, configItem.value]; }));
        });
    }
    Config.get = get;
    function setKey(key, value) {
        return db_1.db.config.put({
            key: key,
            value: value
        });
    }
    Config.setKey = setKey;
    function set(newConfig) {
        return db_1.db.config.bulkPut(_.map(_.toPairs(newConfig), function (pair) { return ({ key: pair[0], value: pair[1] }); }));
    }
    Config.set = set;
})(Config = exports.Config || (exports.Config = {}));


/***/ }),

/***/ "Hoba":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-f3.5b7ae0c2d05c4e28148dc866a5094d67.png";

/***/ }),

/***/ "Htyr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-a4.0ef2cddeeac6822a557e42295feb1e3c.png";

/***/ }),

/***/ "HwaM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__("M4fF");
var OpenHint = (function () {
    function OpenHint(row, col, variant) {
        this.row = row;
        this.col = col;
        this.variant = variant;
    }
    OpenHint.prototype.applyTo = function (board) {
        if (!board.isSingle(this.row, this.col)) {
            board.set(this.row, this.col, this.variant);
            return true;
        }
        else
            return false;
    };
    OpenHint.prototype.getType = function () {
        return 0 /* Start */;
    };
    return OpenHint;
}());
exports.OpenHint = OpenHint;
var OpenHintFactory = (function () {
    function OpenHintFactory() {
    }
    OpenHintFactory.prototype.supports = function (options) {
        return options.rows >= 1 && options.cols >= 1;
    };
    OpenHintFactory.prototype.random = function (board) {
        var row = _.random(0, board.rows - 1);
        var col = _.random(0, board.cols - 1);
        return new OpenHint(row, col, board.get(row, col));
    };
    return OpenHintFactory;
}());
exports.OpenHintFactory = OpenHintFactory;


/***/ }),

/***/ "I4NM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function median(arr) {
    var n = arr.length;
    if (n % 2 === 0)
        return (arr[n / 2 - 1] + arr[n / 2]) / 2;
    else
        return arr[(n - 1) / 2];
}
exports.median = median;
// Tukey's hinges (include median) - https://en.wikipedia.org/wiki/Quartile#Method_2
function lowerQuartile(arr) {
    var n = arr.length;
    var end = n % 2 === 0 ? n / 2 : (n + 1) / 2;
    return median(arr.slice(0, end));
}
exports.lowerQuartile = lowerQuartile;
function upperQuartile(arr) {
    var n = arr.length;
    var start = n % 2 === 0 ? n / 2 : (n - 1) / 2;
    return median(arr.slice(start));
}
exports.upperQuartile = upperQuartile;


/***/ }),

/***/ "IJZH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/hint-between.4800cdbe6818a1ee91adb4003d1dc435.png";

/***/ }),

/***/ "In3e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var _ = __webpack_require__("M4fF");
var preact_1 = __webpack_require__("rMlB");
__webpack_require__("Jd+4");
__webpack_require__("uyRy");
var Counts_1 = __webpack_require__("7Stf");
var Times_1 = __webpack_require__("vO/K");
var time_1 = __webpack_require__("5AqA");
var PuzzleOptionsUtils_1 = __webpack_require__("fdQW");
var statistics = __webpack_require__("9OCd");
var sortedStatistics = __webpack_require__("I4NM");
var HighscoreItemComponent = (function (_super) {
    tslib_1.__extends(HighscoreItemComponent, _super);
    function HighscoreItemComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HighscoreItemComponent.prototype.render = function (props) {
        return (preact_1.h("tr", null,
            preact_1.h("td", { class: "highscore-i" }, props.i + 1 + "."),
            preact_1.h("td", { class: "highscore-name", title: props.item.date.toString() }, props.item.name),
            preact_1.h("td", { class: "highscore-time" }, time_1.formatDuration(props.item.time))));
    };
    return HighscoreItemComponent;
}(preact_1.Component));
var HighscoreTableComponent = (function (_super) {
    tslib_1.__extends(HighscoreTableComponent, _super);
    function HighscoreTableComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HighscoreTableComponent.prototype.render = function (props) {
        return (preact_1.h("table", { class: "highscore" },
            preact_1.h("thead", null,
                preact_1.h("tr", null,
                    preact_1.h("th", { class: "highscore-i" }, "#\u00A0"),
                    preact_1.h("th", { class: "highscore-name" }, "Name"),
                    preact_1.h("th", { class: "highscore-time" }, "Time"))),
            preact_1.h("tbody", null, props.top10 !== undefined && props.top10.length > 0 ?
                _.map(props.top10, function (timesItem, i) {
                    return preact_1.h(HighscoreItemComponent, { i: i, item: timesItem });
                }) :
                preact_1.h("tr", { class: "highscore-text" },
                    preact_1.h("td", { colSpan: 3 }, props.top10 !== undefined ?
                        "No times" :
                        "Loading...")))));
    };
    return HighscoreTableComponent;
}(preact_1.Component));
var StatsComponent = (function (_super) {
    tslib_1.__extends(StatsComponent, _super);
    function StatsComponent(props) {
        var _this = _super.call(this) || this;
        _this.state = {
            counts: undefined
        };
        _this.fetchCounts(props);
        return _this;
    }
    StatsComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.options !== nextProps.options) {
            this.fetchCounts(nextProps);
        }
    };
    StatsComponent.prototype.fetchCounts = function (props) {
        var _this = this;
        Counts_1.Counts.get(props.options).then(function (countsItem) {
            _this.setState({
                counts: countsItem
            });
        });
    };
    StatsComponent.prototype.render = function (props, state) {
        var stats = props.stats;
        var counts = state.counts;
        if (stats !== undefined && counts !== undefined) {
            var total_1 = counts.solved + counts.solvedCheated + counts.over;
            var countWithPercentage = function (count) {
                var percentage = count / total_1 * 100;
                return (preact_1.h("dd", null,
                    count,
                    " ",
                    preact_1.h("small", { class: "small-number" },
                        "(",
                        percentage.toFixed(0),
                        "%)")));
            };
            return (preact_1.h("div", { class: "stats" },
                preact_1.h("dl", null,
                    preact_1.h("div", null,
                        preact_1.h("dt", null, "Games played"),
                        preact_1.h("dd", null, total_1)),
                    preact_1.h("dl", null,
                        preact_1.h("div", null,
                            preact_1.h("dt", null, "Solved"),
                            countWithPercentage(counts.solved)),
                        preact_1.h("div", null,
                            preact_1.h("dt", null,
                                "Solved ",
                                preact_1.h("small", null, "w/"),
                                " cheats"),
                            countWithPercentage(counts.solvedCheated)),
                        preact_1.h("div", null,
                            preact_1.h("dt", null, "Over"),
                            countWithPercentage(counts.over))),
                    preact_1.h("div", null,
                        preact_1.h("dt", null, "Time average"),
                        preact_1.h("dd", null, time_1.formatDuration(stats.mean))),
                    preact_1.h("dl", null,
                        preact_1.h("div", null,
                            preact_1.h("dt", null, "Std. dev."),
                            preact_1.h("dd", null, time_1.formatDuration(stats.stdDev)))),
                    preact_1.h("div", null,
                        preact_1.h("dt", null, "Time quartiles")),
                    preact_1.h("dl", null,
                        preact_1.h("div", null,
                            preact_1.h("dt", null,
                                "Lower ",
                                preact_1.h("small", null, "(25%)")),
                            preact_1.h("dd", null, time_1.formatDuration(stats.lowerQuartile))),
                        preact_1.h("div", null,
                            preact_1.h("dt", null,
                                "Median ",
                                preact_1.h("small", null, "(50%)")),
                            preact_1.h("dd", null, time_1.formatDuration(stats.median))),
                        preact_1.h("div", null,
                            preact_1.h("dt", null,
                                "Upper ",
                                preact_1.h("small", null, "(75%)")),
                            preact_1.h("dd", null, time_1.formatDuration(stats.upperQuartile))),
                        preact_1.h("div", null,
                            preact_1.h("dt", null, "Max"),
                            preact_1.h("dd", null, time_1.formatDuration(stats.max)))))));
        }
        else
            return null;
    };
    return StatsComponent;
}(preact_1.Component));
var HighscoreComponent = (function (_super) {
    tslib_1.__extends(HighscoreComponent, _super);
    function HighscoreComponent(props) {
        var _this = _super.call(this) || this;
        _this.state = {
            top10: undefined,
            stats: undefined
        };
        _this.fetchTimes(props);
        return _this;
    }
    HighscoreComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.options !== nextProps.options) {
            this.fetchTimes(nextProps);
        }
    };
    HighscoreComponent.calculateStats = function (timesItems) {
        var sortedTimes = _.map(timesItems, "time");
        var mean = statistics.mean(sortedTimes);
        return {
            count: sortedTimes.length,
            mean: mean,
            stdDev: statistics.stdDev(sortedTimes, mean),
            lowerQuartile: sortedStatistics.lowerQuartile(sortedTimes),
            median: sortedStatistics.median(sortedTimes),
            upperQuartile: sortedStatistics.upperQuartile(sortedTimes),
            max: _.max(sortedTimes) // never undefined because always has times
        };
    };
    HighscoreComponent.prototype.fetchTimes = function (props) {
        var _this = this;
        Times_1.Times.getSortedTimes(props.options).then(function (timesItems) {
            _this.setState({
                top10: _.take(timesItems, 10),
                stats: HighscoreComponent.calculateStats(timesItems)
            });
        });
    };
    HighscoreComponent.prototype.render = function (props, state) {
        return (preact_1.h("div", { class: "highscore-outer" },
            preact_1.h("div", { class: "highscore-title" }, PuzzleOptionsUtils_1.formatOptions(props.options)),
            preact_1.h(HighscoreTableComponent, { top10: state.top10 }),
            preact_1.h("hr", null),
            preact_1.h(StatsComponent, { options: props.options, stats: state.stats })));
    };
    return HighscoreComponent;
}(preact_1.Component));
exports.HighscoreComponent = HighscoreComponent;


/***/ }),

/***/ "JIJM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__("M4fF");
var SameColumnHint = (function () {
    function SameColumnHint(row1, variant1, row2, variant2) {
        this.row1 = row1;
        this.variant1 = variant1;
        this.row2 = row2;
        this.variant2 = variant2;
    }
    SameColumnHint.prototype.applyTo = function (board) {
        var changed = false;
        for (var col = 0; col < board.cols; col++) {
            var possible1 = board.isPossible(this.row1, col, this.variant1);
            var possible2 = board.isPossible(this.row2, col, this.variant2);
            if (!possible1 && possible2) {
                board.remove(this.row2, col, this.variant2);
                changed = true;
            }
            else if (possible1 && !possible2) {
                board.remove(this.row1, col, this.variant1);
                changed = true;
            }
        }
        return changed;
    };
    SameColumnHint.prototype.getType = function () {
        return 2 /* Vertical */;
    };
    return SameColumnHint;
}());
exports.SameColumnHint = SameColumnHint;
var SameColumnHintFactory = (function () {
    function SameColumnHintFactory() {
    }
    SameColumnHintFactory.prototype.supports = function (options) {
        return options.rows >= 2 && options.cols >= 1;
    };
    SameColumnHintFactory.prototype.random = function (board) {
        var col = _.random(0, board.cols - 1);
        var row1 = _.random(0, board.rows - 1);
        var row2;
        do {
            row2 = _.random(0, board.rows - 1);
        } while (row2 == row1);
        return new SameColumnHint(row1, board.get(row1, col), row2, board.get(row2, col));
    };
    return SameColumnHintFactory;
}());
exports.SameColumnHintFactory = SameColumnHintFactory;


/***/ }),

/***/ "JMRT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var _ = __webpack_require__("M4fF");
var Board_1 = __webpack_require__("bWR4");
var MultiBoard_1 = __webpack_require__("CBd9");
var SingleBoard = (function (_super) {
    tslib_1.__extends(SingleBoard, _super);
    function SingleBoard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SingleBoard.random = function (options) {
        return new SingleBoard(_.times(options.rows, function (row) { return _.shuffle(_.range(options.cols)); }), options);
    };
    SingleBoard.prototype.getCol = function (row, variant) {
        for (var col = 0; col < this.cols; col++) {
            if (this.get(row, col) === variant)
                return col;
        }
        return -1;
    };
    SingleBoard.prototype.isSolvable = function (hints) {
        var multiBoard = MultiBoard_1.MultiBoard.full(this.options);
        multiBoard.applyHints(hints);
        return multiBoard.isSolved(this);
    };
    return SingleBoard;
}(Board_1.Board));
exports.SingleBoard = SingleBoard;


/***/ }),

/***/ "Jd+4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JpXf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KBc0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var classNames = __webpack_require__("HW6M");
var _ = __webpack_require__("M4fF");
var preact_1 = __webpack_require__("rMlB");
var AdjacentHint_1 = __webpack_require__("2+Yo");
var BetweenHint_1 = __webpack_require__("DAXx");
var DirectionHint_1 = __webpack_require__("X9r5");
var SameColumnHint_1 = __webpack_require__("JIJM");
var LongTouchContextMenuHandler_1 = __webpack_require__("euc6");
__webpack_require__("TjjG");
var IconComponents_1 = __webpack_require__("NsAh");
var HintComponent = (function (_super) {
    tslib_1.__extends(HintComponent, _super);
    function HintComponent() {
        var _this = _super.call(this) || this;
        _this.contextMenuHandler = new LongTouchContextMenuHandler_1.LongTouchContextMenuHandler(function () { return _this.onToggle(); });
        _this.onToggle = function () {
            _this.setState(function (state) {
                return {
                    visible: !state.visible
                };
            });
        };
        _this.state = {
            visible: true
        };
        return _this;
    }
    HintComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.hint !== nextProps.hint) {
            this.setState({
                visible: true
            });
        }
    };
    HintComponent.prototype.renderTbody = function (props) {
        var hint = props.hint;
        if (hint instanceof AdjacentHint_1.AdjacentHint) {
            return (preact_1.h("tbody", null,
                preact_1.h("tr", null,
                    preact_1.h("td", null,
                        preact_1.h(IconComponents_1.LargeVariantIconComponent, { row: hint.row1, variant: hint.variant1 })),
                    preact_1.h("td", null,
                        preact_1.h(IconComponents_1.IconComponent, { name: "hint-adjacent" })),
                    preact_1.h("td", null,
                        preact_1.h(IconComponents_1.LargeVariantIconComponent, { row: hint.row2, variant: hint.variant2 })))));
        }
        else if (hint instanceof BetweenHint_1.BetweenHint) {
            return (preact_1.h("tbody", null,
                preact_1.h("tr", null,
                    preact_1.h("td", null,
                        preact_1.h(IconComponents_1.LargeVariantIconComponent, { row: hint.row1, variant: hint.variant1 })),
                    preact_1.h("td", null,
                        preact_1.h(IconComponents_1.LargeVariantIconComponent, { row: hint.rowMiddle, variant: hint.variantMiddle }),
                        preact_1.h("div", { class: "hint-between" },
                            preact_1.h(IconComponents_1.IconComponent, { name: "hint-between" }))),
                    preact_1.h("td", null,
                        preact_1.h(IconComponents_1.LargeVariantIconComponent, { row: hint.row2, variant: hint.variant2 })))));
        }
        else if (hint instanceof DirectionHint_1.DirectionHint) {
            return (preact_1.h("tbody", null,
                preact_1.h("tr", null,
                    preact_1.h("td", null,
                        preact_1.h(IconComponents_1.LargeVariantIconComponent, { row: hint.rowLeft, variant: hint.variantLeft })),
                    preact_1.h("td", null,
                        preact_1.h(IconComponents_1.IconComponent, { name: "hint-direction" })),
                    preact_1.h("td", null,
                        preact_1.h(IconComponents_1.LargeVariantIconComponent, { row: hint.rowRight, variant: hint.variantRight })))));
        }
        else if (hint instanceof SameColumnHint_1.SameColumnHint) {
            return (preact_1.h("tbody", null,
                preact_1.h("tr", null,
                    preact_1.h("td", null,
                        preact_1.h(IconComponents_1.LargeVariantIconComponent, { row: hint.row1, variant: hint.variant1 }))),
                preact_1.h("tr", null,
                    preact_1.h("td", null,
                        preact_1.h(IconComponents_1.LargeVariantIconComponent, { row: hint.row2, variant: hint.variant2 })))));
        }
        else
            throw new Error("Unsupported hint type");
    };
    HintComponent.prototype.render = function (props, state) {
        return (preact_1.h("div", tslib_1.__assign({ class: classNames({
                "hint-outer": true,
                "hint-visible": state.visible,
                "hint-hidden": !state.visible
            }) }, this.contextMenuHandler),
            preact_1.h("table", { class: "hint" }, this.renderTbody(props))));
    };
    return HintComponent;
}(preact_1.Component));
var HintsComponent = (function (_super) {
    tslib_1.__extends(HintsComponent, _super);
    function HintsComponent() {
        var _this = _super.call(this) || this;
        _this.onToggle = function (e) {
            _this.setState(function (state) {
                return {
                    visible: !state.visible
                };
            });
        };
        _this.state = {
            visible: true
        };
        return _this;
    }
    HintsComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.hints !== nextProps.hints) {
            this.setState({
                visible: true
            });
        }
    };
    HintsComponent.prototype.render = function (props, state) {
        return (preact_1.h("div", { class: "hints" },
            preact_1.h("button", { class: "button-toggle", onClick: this.onToggle }, "Toggle"),
            preact_1.h("div", { class: classNames({
                    "hints-horizontal": true,
                    "hints-visible": state.visible,
                    "hints-hidden": !state.visible
                }) },
                _.map(_.filter(props.hints, function (hint) { return hint.getType() === 1 /* Horizontal */; }), function (hint) {
                    return preact_1.h(HintComponent, { hint: hint });
                }),
                _.map(_.filter(props.hints, function (hint) { return hint.getType() === 2 /* Vertical */; }), function (hint) {
                    return preact_1.h(HintComponent, { hint: hint });
                }))));
    };
    return HintsComponent;
}(preact_1.Component));
exports.HintsComponent = HintsComponent;


/***/ }),

/***/ "MZjJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function isWasmSupported() {
    // https://stackoverflow.com/a/47880734/854540
    // TODO more thorough check
    return typeof WebAssembly === "object";
}
exports.isWasmSupported = isWasmSupported;


/***/ }),

/***/ "MjYr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-f5.72cc42d0d642b89a43f7d5dae38777d0.png";

/***/ }),

/***/ "N7YA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-a6.4ac50d73cecffe7683129cb537280e02.png";

/***/ }),

/***/ "Nf2I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var _ = __webpack_require__("M4fF");
var Z3_1 = __webpack_require__("aDup");
var AdjacentHint_1 = __webpack_require__("2+Yo");
var BetweenHint_1 = __webpack_require__("DAXx");
var DirectionHint_1 = __webpack_require__("X9r5");
var OpenHint_1 = __webpack_require__("HwaM");
var SameColumnHint_1 = __webpack_require__("JIJM");
var RandomHint_1 = __webpack_require__("gYeE");
var Z3HintsGenerator = (function () {
    function Z3HintsGenerator() {
    }
    Z3HintsGenerator.prototype.supports = function (options) {
        return Z3HintsGenerator.hintFactory.supports(options);
    };
    Z3HintsGenerator.prototype.generate = function (options, board) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, hints;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.debug("getZ3");
                        _a = this;
                        return [4 /*yield*/, Z3_1.getZ3()];
                    case 1:
                        _a.z3 = _b.sent();
                        this.makeContext();
                        // this.ask("(set-option :produce-unsat-cores true)"); // TODO: why parser error?
                        this.assertBoard(board);
                        hints = this.generateHints(board);
                        hints = this.pruneHints(board, hints);
                        this.deleteContext();
                        return [2 /*return*/, hints];
                }
            });
        });
    };
    Z3HintsGenerator.prototype.makeContext = function () {
        console.debug("makeContext");
        this.z3.global_param_set("unsat_core", "true");
        this.z3.global_param_set("smt.core.minimize", "true");
        var cfg = this.z3.mk_config();
        this.ctx = this.z3.mk_context(cfg);
        this.z3.set_error_handler(this.ctx, this.z3.errorHandler);
        this.z3.del_config(cfg);
    };
    Z3HintsGenerator.prototype.ask = function (smtlib2) {
        // console.debug(smtlib2);
        return this.z3.eval_smtlib2_string(this.ctx, smtlib2).trim();
    };
    Z3HintsGenerator.prototype.deleteContext = function () {
        console.debug("deleteContext");
        this.z3.del_context(this.ctx);
    };
    Z3HintsGenerator.prototype.generateHints = function (board) {
        var hints = [];
        while (!this.isUniqueSolvable()) {
            var hint = Z3HintsGenerator.hintFactory.random(board);
            hints.push(hint);
            var i = hints.length - 1;
            var constraint = Z3HintsGenerator.getHintConstraint(hint);
            this.ask("(assert (! " + constraint + " :named h" + i + "))");
        }
        return hints;
    };
    Z3HintsGenerator.prototype.pruneHints = function (board, hints) {
        console.debug("Before pruneHints: " + hints.length);
        var getUnsatCore = this.ask("(get-unsat-core)");
        console.debug(getUnsatCore);
        var coreIs = _.map(getUnsatCore.match(/\d+/g), function (i) { return parseInt(i); });
        hints = _.filter(hints, function (hint, i) { return _.includes(coreIs, i); });
        console.debug("After pruneHints: " + hints.length);
        return hints;
    };
    Z3HintsGenerator.prototype.isUniqueSolvable = function () {
        var checkSat = this.ask("(check-sat)");
        var unique = checkSat == "unsat";
        return unique;
    };
    Z3HintsGenerator.prototype.assertBoard = function (board) {
        console.debug("assertBoard");
        for (var row = 0; row < board.rows; row++) {
            var xs = "";
            for (var variant = 0; variant < board.variants; variant++) {
                var x = "x" + row + variant;
                this.ask("(declare-const " + x + " Int)");
                this.ask("(assert (and (<= 0 " + x + ") (< " + x + " " + board.cols + ")))");
                xs += " " + x;
            }
            this.ask("(assert (distinct" + xs + "))");
        }
        var ds = "";
        for (var row = 0; row < board.rows; row++) {
            for (var col = 0; col < board.cols; col++) {
                var variant = board.get(row, col);
                var x = "x" + row + variant;
                ds += " (distinct " + x + " " + col + ")";
            }
        }
        this.ask("(assert (or" + ds + "))");
    };
    Z3HintsGenerator.getHintConstraint = function (hint) {
        if (hint instanceof AdjacentHint_1.AdjacentHint) {
            var x1 = "x" + hint.row1 + hint.variant1;
            var x2 = "x" + hint.row2 + hint.variant2;
            return "(or (= " + x1 + " (+ " + x2 + " 1)) (= " + x1 + " (- " + x2 + " 1)))";
        }
        else if (hint instanceof BetweenHint_1.BetweenHint) {
            var x1 = "x" + hint.row1 + hint.variant1;
            var xMiddle = "x" + hint.rowMiddle + hint.variantMiddle;
            var x2 = "x" + hint.row2 + hint.variant2;
            return "(or (and (= " + xMiddle + " (+ " + x1 + " 1)) (= " + xMiddle + " (- " + x2 + " 1))) (and (= " + xMiddle + " (+ " + x2 + " 1)) (= " + xMiddle + " (- " + x1 + " 1))))";
        }
        else if (hint instanceof DirectionHint_1.DirectionHint) {
            var xLeft = "x" + hint.rowLeft + hint.variantLeft;
            var xRight = "x" + hint.rowRight + hint.variantRight;
            return "(< " + xLeft + " " + xRight + ")";
        }
        else if (hint instanceof OpenHint_1.OpenHint) {
            var x = "x" + hint.row + hint.variant;
            return "(= " + x + " " + hint.col + ")";
        }
        else if (hint instanceof SameColumnHint_1.SameColumnHint) {
            var x1 = "x" + hint.row1 + hint.variant1;
            var x2 = "x" + hint.row2 + hint.variant2;
            return "(= " + x1 + " " + x2 + ")";
        }
        else
            throw new Error("Unsupported hint type");
    };
    Z3HintsGenerator.hintFactory = new RandomHint_1.RandomHintFactory();
    return Z3HintsGenerator;
}());
exports.Z3HintsGenerator = Z3HintsGenerator;


/***/ }),

/***/ "NhLW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-a2.b09094efecdd9eb43f5c9d816a1fe4e3.png";

/***/ }),

/***/ "NsAh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var preact_1 = __webpack_require__("rMlB");
__webpack_require__("JpXf");
// https://webpack.js.org/guides/dependency-management/#context-module-api
var cache = {};
function importAll(r) {
    r.keys().forEach(function (key) { return cache[key] = r(key); });
}
importAll(__webpack_require__("7PiI"));
var IconComponent = (function (_super) {
    tslib_1.__extends(IconComponent, _super);
    function IconComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconComponent.prototype.render = function (props) {
        return (preact_1.h("img", { class: "icon", src: cache["./icons/original/" + props.name + ".png"] }));
    };
    return IconComponent;
}(preact_1.Component));
exports.IconComponent = IconComponent;
var LargeVariantIconComponent = (function (_super) {
    tslib_1.__extends(LargeVariantIconComponent, _super);
    function LargeVariantIconComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LargeVariantIconComponent.prototype.render = function (props) {
        return (preact_1.h(IconComponent, { name: "large/large-" + (props.row + 10).toString(16) + (props.variant + 1) }));
    };
    return LargeVariantIconComponent;
}(preact_1.Component));
exports.LargeVariantIconComponent = LargeVariantIconComponent;
var SmallVariantIconComponent = (function (_super) {
    tslib_1.__extends(SmallVariantIconComponent, _super);
    function SmallVariantIconComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SmallVariantIconComponent.prototype.render = function (props) {
        return (preact_1.h(IconComponent, { name: "small/small-" + (props.row + 10).toString(16) + (props.variant + 1) }));
    };
    return SmallVariantIconComponent;
}(preact_1.Component));
exports.SmallVariantIconComponent = SmallVariantIconComponent;


/***/ }),

/***/ "NsPZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function memoizeSupplier(supplier) {
    var p = null;
    return function () { return p === null ? (p = supplier()) : p; };
}
exports.memoizeSupplier = memoizeSupplier;


/***/ }),

/***/ "Op0r":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/hint-direction.2a6b9db9707be05efc146cbd8e571e2b.png";

/***/ }),

/***/ "P2+R":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-e5.46811d66ca231366ab2e44b4de32bee7.png";

/***/ }),

/***/ "PWPq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-d3.87d7030770383023603c79700050ee58.png";

/***/ }),

/***/ "PvcG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var HintsGenerator_1 = __webpack_require__("S+P+");
var ApplyHintsGenerator = (function (_super) {
    tslib_1.__extends(ApplyHintsGenerator, _super);
    function ApplyHintsGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ApplyHintsGenerator.prototype.isSolvable = function (board, hints) {
        return board.isSolvable(hints);
    };
    return ApplyHintsGenerator;
}(HintsGenerator_1.SolvableHintsGenerator));
exports.ApplyHintsGenerator = ApplyHintsGenerator;


/***/ }),

/***/ "QP0S":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-a1.d73d5dfe6e49493fa72128c7d36eca4e.png";

/***/ }),

/***/ "QfaF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-f6.2f7d8a98586b23b3f348bef4350bf4f7.png";

/***/ }),

/***/ "Qj03":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/hint-adjacent.7b5864dbf0656526063d96f271c1e5fc.png";

/***/ }),

/***/ "RUP8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-b3.65f5bcb765e8dc6f37ec5174e112cea4.png";

/***/ }),

/***/ "S+P+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var _ = __webpack_require__("M4fF");
var RandomHint_1 = __webpack_require__("gYeE");
var DelegateHintsGenerator = (function () {
    function DelegateHintsGenerator(delegate) {
        this.delegate = delegate;
    }
    DelegateHintsGenerator.prototype.supports = function (options) {
        return this.delegate.supports(options);
    };
    return DelegateHintsGenerator;
}());
exports.DelegateHintsGenerator = DelegateHintsGenerator;
var SolvableHintsGenerator = (function () {
    function SolvableHintsGenerator() {
    }
    SolvableHintsGenerator.prototype.supports = function (options) {
        return SolvableHintsGenerator.hintFactory.supports(options);
    };
    SolvableHintsGenerator.prototype.generate = function (options, board) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var hints;
            return tslib_1.__generator(this, function (_a) {
                hints = this.generateHints(board);
                return [2 /*return*/, this.pruneHints(board, hints)];
            });
        });
    };
    SolvableHintsGenerator.prototype.generateHints = function (board) {
        var hints = [];
        while (!this.isSolvable(board, hints)) {
            var hint = SolvableHintsGenerator.hintFactory.random(board);
            hints.push(hint);
        }
        return hints;
    };
    SolvableHintsGenerator.prototype.pruneHints = function (board, hints) {
        hints = _.clone(hints);
        console.debug("Before pruneHints: " + hints.length);
        for (var i = 0; i < hints.length;) {
            var hint = hints.splice(i, 1)[0];
            if (this.isSolvable(board, hints)) {
                // keep i which now points to next hint
            }
            else {
                hints.splice(i, 0, hint);
                i++;
            }
        }
        console.debug("After pruneHints: " + hints.length);
        return hints;
    };
    SolvableHintsGenerator.hintFactory = new RandomHint_1.RandomHintFactory();
    return SolvableHintsGenerator;
}());
exports.SolvableHintsGenerator = SolvableHintsGenerator;


/***/ }),

/***/ "SAo3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-e4.07420566e5a63e3313fa48704100c22f.png";

/***/ }),

/***/ "SCQN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-e1.abbe71866b879431f7d1ec2f736260f3.png";

/***/ }),

/***/ "SLpm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var classNames = __webpack_require__("HW6M");
var dexie_1 = __webpack_require__("dlzC");
var _ = __webpack_require__("M4fF");
var Package = __webpack_require__("7YgM");
var preact_1 = __webpack_require__("rMlB");
var PuzzleGenerator_1 = __webpack_require__("cnN+");
var Config_1 = __webpack_require__("HZR3");
var Counts_1 = __webpack_require__("7Stf");
var db_1 = __webpack_require__("ATbC");
var Times_1 = __webpack_require__("vO/K");
var time_1 = __webpack_require__("5AqA");
var Timer_1 = __webpack_require__("32Ag");
__webpack_require__("2JYO");
var HighscoreComponent_1 = __webpack_require__("In3e");
var HintsComponent_1 = __webpack_require__("KBc0");
var MultiBoardComponent_1 = __webpack_require__("ziB5");
var PuzzleOptionsUtils_1 = __webpack_require__("fdQW");
var TimerComponent_1 = __webpack_require__("etg9");
var VisibilityChangeListener_1 = __webpack_require__("yFiT");
var MessageUnloadListener_1 = __webpack_require__("Agl8");
var BirthdayComponent_1 = __webpack_require__("ouBu");
var OptionsComponent_1 = __webpack_require__("b/H4");
var GameState;
(function (GameState) {
    GameState[GameState["Options"] = 0] = "Options";
    GameState[GameState["Highscore"] = 1] = "Highscore";
    GameState[GameState["Generating"] = 2] = "Generating";
    GameState[GameState["Playing"] = 3] = "Playing";
    GameState[GameState["ManualPaused"] = 4] = "ManualPaused";
    GameState[GameState["AutoPaused"] = 5] = "AutoPaused";
    GameState[GameState["Solved"] = 6] = "Solved";
    GameState[GameState["Over"] = 7] = "Over";
})(GameState = exports.GameState || (exports.GameState = {}));
var AppComponent = (function (_super) {
    tslib_1.__extends(AppComponent, _super);
    function AppComponent() {
        var _this = _super.call(this) || this;
        _this.timer = new Timer_1.Timer();
        _this.puzzleGenerator = PuzzleGenerator_1.mainPuzzleGenerator;
        _this.onClickNewGame = function (e) {
            _this.setState({
                gameState: GameState.Options,
                cheated: 0
            });
            _this.timer.reset();
        };
        _this.onClickPause = function (e) {
            if (_this.state.gameState === GameState.Playing) {
                _this.timer.pause();
                _this.setState(function (state) { return _.merge(state, {
                    gameState: GameState.ManualPaused
                }); });
            }
        };
        _this.onClickResume = function (e) {
            if (_this.state.gameState === GameState.ManualPaused || _this.state.gameState === GameState.AutoPaused) {
                _this.timer.start();
                _this.setState(function (state) { return _.merge(state, {
                    gameState: GameState.Playing
                }); });
            }
        };
        _this.onClickCheat = function (e) {
            if (_this.state.gameState === GameState.Playing) {
                _this.setState(function (state) {
                    var changed = state.puzzle.applySingleHint();
                    return _.merge(state, {
                        cheated: state.cheated + (changed ? 1 : 0)
                    });
                }, _this.refresh);
            }
        };
        _this.onVisibilityChange = function (visible) {
            if (visible && _this.state.gameState === GameState.AutoPaused) {
                _this.timer.start();
                _this.setState(function (state) { return _.merge(state, {
                    gameState: GameState.Playing
                }); });
            }
            else if (!visible && _this.state.gameState === GameState.Playing) {
                _this.timer.pause();
                _this.setState(function (state) { return _.merge(state, {
                    gameState: GameState.AutoPaused
                }); });
            }
        };
        _this.onMessageUnload = function () {
            switch (_this.state.gameState) {
                case GameState.Playing:
                case GameState.ManualPaused:
                case GameState.AutoPaused:
                    return "Are you sure you want to leave while the game is in progress?";
                default:
                    return null;
            }
        };
        _this.submitOptions = function (options) {
            _this.configOptions(options);
            _this.setState({
                gameState: GameState.Generating
            }, function () {
                // this.forceUpdate(); // seems to make no difference
                requestAnimationFrame(function (time) {
                    setTimeout(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        var puzzle, e_1;
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, this.puzzleGenerator.generate(options)];
                                case 1:
                                    puzzle = _a.sent();
                                    this.setState({
                                        puzzle: puzzle,
                                        gameState: GameState.Playing,
                                        cheated: 0,
                                        canCheat: true
                                    }, function () {
                                        _this.timer.start();
                                        _this.refresh(); // check win in case everything opened on start
                                    });
                                    return [3 /*break*/, 3];
                                case 2:
                                    e_1 = _a.sent();
                                    alert(e_1);
                                    this.setState({
                                        puzzle: undefined,
                                        gameState: GameState.Options,
                                        cheated: 0,
                                        canCheat: undefined
                                    });
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); }, 0); // timeout to start generation AFTER repaint (hopefully)
                });
            });
        };
        _this.highscoreOptions = function (options) {
            _this.configOptions(options);
            _this.setState({
                gameState: GameState.Highscore
            });
        };
        _this.refresh = function () {
            if (_this.state.gameState === GameState.Playing) {
                var puzzle_1 = _this.state.puzzle;
                if (puzzle_1.isSolved()) {
                    _this.timer.pause();
                    var time_2 = _this.timer.getTotalTime();
                    _this.setState(function (state) { return _.merge(state, {
                        gameState: GameState.Solved
                    }); }, function () {
                        var options = puzzle_1.options;
                        var cheated = _this.state.cheated;
                        Counts_1.Counts.increase(options, cheated ? "solvedCheated" : "solved");
                        var cheatedText = cheated > 0 ? " by cheating " + cheated + " times" : "";
                        alert("Solved " + PuzzleOptionsUtils_1.formatOptions(options) + " in " + time_1.formatDuration(time_2) + cheatedText + "!");
                        if (!cheated) {
                            db_1.db.transaction("rw", db_1.db.times, db_1.db.config, function () {
                                return Times_1.Times.isInTop10(options, time_2).then(function (isInTop10) {
                                    return Config_1.Config.getKey("name").then(function (defaultName) {
                                        var name;
                                        if (isInTop10 !== false &&
                                            (name = prompt("Enter name for " + (isInTop10 + 1) + ". place in high scores:", defaultName)) !== null)
                                            return name;
                                        else
                                            return undefined;
                                    });
                                }).then(function (name) {
                                    return dexie_1.default.Promise.all([
                                        Times_1.Times.add(options, time_2, name),
                                        Config_1.Config.setKey("name", name)
                                    ]);
                                });
                            });
                        }
                    });
                }
                else if (puzzle_1.isOver()) {
                    _this.timer.pause();
                    _this.setState(function (state) { return _.merge(state, {
                        gameState: GameState.Over
                    }); }, function () {
                        Counts_1.Counts.increase(puzzle_1.options, "over");
                        alert("Over!");
                    });
                }
                else {
                    _this.setState({
                        canCheat: puzzle_1.canApplySingleHint()
                    });
                }
            }
        };
        _this.state = {
            options: AppComponent.defaultOptions,
            puzzle: undefined,
            gameState: GameState.Options,
            cheated: 0,
            canCheat: undefined
        };
        _this.visibilityChange = new VisibilityChangeListener_1.VisibilityChangeListener(_this.onVisibilityChange);
        _this.messageUnload = new MessageUnloadListener_1.MessageUnloadListener(_this.onMessageUnload);
        Config_1.Config.getKey("options").then(function (options) {
            if (options !== undefined) {
                _this.setState({
                    options: options
                });
            }
        });
        return _this;
    }
    AppComponent.prototype.componentDidMount = function () {
        this.visibilityChange.add();
        this.messageUnload.add();
    };
    AppComponent.prototype.componentWillUnmount = function () {
        this.visibilityChange.remove();
        this.messageUnload.remove();
    };
    AppComponent.prototype.configOptions = function (options) {
        this.setState({
            options: options
        });
        Config_1.Config.set({
            options: options
        });
    };
    AppComponent.prototype.render = function (props, state) {
        var solvedOrOver = state.gameState === GameState.Solved || state.gameState === GameState.Over;
        var showBoard = solvedOrOver ? state.puzzle.singleBoard : undefined;
        return (preact_1.h("div", { class: classNames({
                "app": true,
                "paused": state.gameState === GameState.ManualPaused || state.gameState === GameState.AutoPaused,
                "solved": state.gameState === GameState.Solved,
                "over": state.gameState === GameState.Over,
                "cheated": state.cheated > 0
            }) },
            preact_1.h("div", { class: "app-top" },
                preact_1.h("div", { class: "header" },
                    preact_1.h("div", { class: "brand" },
                        preact_1.h("a", { href: "https://einstein.sim642.eu", title: "einstein-js " + Package.version }, "einstein-js"),
                        " ",
                        preact_1.h("small", null,
                            "by ",
                            preact_1.h("a", { href: "https://github.com/sim642/einstein-js" }, "sim642"))),
                    preact_1.h("div", { class: "buttons buttons-responsive" },
                        preact_1.h("button", { class: classNames({
                                "button-highlight": solvedOrOver || state.gameState === GameState.Highscore
                            }), disabled: state.gameState === GameState.Generating, onClick: this.onClickNewGame }, "New game"),
                        preact_1.h("button", { disabled: !(state.gameState === GameState.Playing && state.canCheat), onClick: this.onClickCheat },
                            "Cheat ",
                            state.cheated > 0 ?
                                preact_1.h("span", { class: "badge" }, state.cheated) :
                                null),
                        state.gameState === GameState.ManualPaused || state.gameState === GameState.AutoPaused ?
                            preact_1.h("button", { class: "button-highlight", onClick: this.onClickResume }, "Resume") :
                            preact_1.h("button", { disabled: state.gameState !== GameState.Playing, onClick: this.onClickPause }, "Pause")),
                    preact_1.h(TimerComponent_1.TimerComponent, { timer: this.timer })),
                preact_1.h(BirthdayComponent_1.BirthdayComponent, { month: 10, day: 22, name: "Elisabeth" }),
                state.gameState === GameState.Options || state.gameState === GameState.Generating ?
                    preact_1.h(OptionsComponent_1.OptionsComponent, { options: state.options, submit: this.submitOptions, highscore: this.highscoreOptions, defaultOptions: AppComponent.defaultOptions, puzzleGenerator: this.puzzleGenerator, generating: state.gameState === GameState.Generating }) :
                    state.gameState === GameState.Highscore ?
                        preact_1.h(HighscoreComponent_1.HighscoreComponent, { options: state.options }) :
                        preact_1.h(MultiBoardComponent_1.MultiBoardComponent, { board: state.puzzle.multiBoard, refresh: this.refresh, showBoard: showBoard })),
            state.gameState !== GameState.Options && state.gameState !== GameState.Highscore && state.gameState !== GameState.Generating ?
                preact_1.h(HintsComponent_1.HintsComponent, { hints: state.puzzle.hints }) :
                null));
    };
    AppComponent.defaultOptions = {
        rows: 6,
        cols: 6,
        extraHintsPercent: 0,
        difficulty: "normal"
    };
    return AppComponent;
}(preact_1.Component));
exports.AppComponent = AppComponent;


/***/ }),

/***/ "Seff":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var _ = __webpack_require__("M4fF");
var AbstractDistribution_1 = __webpack_require__("bwb8");
var PairsDistribution = (function (_super) {
    tslib_1.__extends(PairsDistribution, _super);
    function PairsDistribution(pairs) {
        var _this = _super.call(this) || this;
        _this.pairs = pairs;
        return _this;
    }
    PairsDistribution.prototype.find = function (value) {
        return PairsDistribution.find(this.pairs, value);
    };
    PairsDistribution.prototype.get = function (value) {
        var pair = this.find(value);
        return pair !== undefined ? pair[1] : undefined;
    };
    Object.defineProperty(PairsDistribution.prototype, "n", {
        get: function () {
            return _.sumBy(this.pairs, function (pair) { return pair[1]; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PairsDistribution.prototype, "classes", {
        get: function () {
            return this.pairs.length;
        },
        enumerable: true,
        configurable: true
    });
    PairsDistribution.prototype.mapFreqs = function (f) {
        return new PairsDistribution(this.map(function (freq, value) { return [value, f(freq, value)]; }));
    };
    PairsDistribution.prototype.map = function (f) {
        return _.map(this.pairs, function (_a) {
            var value = _a[0], freq = _a[1];
            return f(freq, value);
        });
    };
    PairsDistribution.prototype.filter = function (p) {
        return new PairsDistribution(_.filter(this.pairs, function (_a) {
            var value = _a[0], freq = _a[1];
            return p(freq, value);
        }));
    };
    PairsDistribution.find = function (pairs, value) {
        return _.find(pairs, function (pair) { return pair[0] === value; });
    };
    PairsDistribution.monteCarlo = function (n, generator) {
        var observed = [];
        for (var i = 0; i < n; i++) {
            var value = generator();
            var pair = PairsDistribution.find(observed, value);
            if (pair === undefined) {
                pair = [value, 0];
                observed.push(pair);
            }
            pair[1]++;
        }
        return new PairsDistribution(observed);
    };
    PairsDistribution.prototype.toPairs = function () {
        return this.pairs;
    };
    return PairsDistribution;
}(AbstractDistribution_1.AbstractDistribution));
exports.PairsDistribution = PairsDistribution;


/***/ }),

/***/ "TeOI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-a5.e5df7839ecedea6b66da59aa3ece9ba8.png";

/***/ }),

/***/ "TjjG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UBU4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-b1.67391202fba98a1797a9c666a9f2d723.png";

/***/ }),

/***/ "X9r5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__("M4fF");
var DirectionHint = (function () {
    function DirectionHint(rowLeft, variantLeft, rowRight, variantRight) {
        this.rowLeft = rowLeft;
        this.variantLeft = variantLeft;
        this.rowRight = rowRight;
        this.variantRight = variantRight;
    }
    DirectionHint.prototype.applyTo = function (board) {
        var changed = false;
        for (var col = 0; col < board.cols; col++) {
            if (board.isPossible(this.rowRight, col, this.variantRight)) {
                board.remove(this.rowRight, col, this.variantRight);
                changed = true;
            }
            if (board.isPossible(this.rowLeft, col, this.variantLeft))
                break;
        }
        for (var col = board.cols - 1; col >= 0; col--) {
            if (board.isPossible(this.rowLeft, col, this.variantLeft)) {
                board.remove(this.rowLeft, col, this.variantLeft);
                changed = true;
            }
            if (board.isPossible(this.rowRight, col, this.variantRight))
                break;
        }
        return changed;
    };
    DirectionHint.prototype.getType = function () {
        return 1 /* Horizontal */;
    };
    return DirectionHint;
}());
exports.DirectionHint = DirectionHint;
var DirectionHintFactory = (function () {
    function DirectionHintFactory() {
    }
    DirectionHintFactory.prototype.supports = function (options) {
        return options.rows >= 1 && options.cols >= 2;
    };
    DirectionHintFactory.prototype.random = function (board) {
        var rowLeft = _.random(0, board.rows - 1);
        var colLeft = _.random(0, board.cols - 2);
        var rowRight = _.random(0, board.rows - 1);
        var colRight = _.random(colLeft + 1, board.cols - 1);
        return new DirectionHint(rowLeft, board.get(rowLeft, colLeft), rowRight, board.get(rowRight, colRight));
    };
    return DirectionHintFactory;
}());
exports.DirectionHintFactory = DirectionHintFactory;


/***/ }),

/***/ "XjqR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-c3.82043ba3661fa5a9afc87cf0c1d9f917.png";

/***/ }),

/***/ "XnXw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-e4.967aa445a182fda8b3261d4612d3a3fc.png";

/***/ }),

/***/ "YFuY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-e6.60a05543c24485dc78b1cb4f47c306be.png";

/***/ }),

/***/ "YKaq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-b5.746416be364e3c33aacd6055c476fbc5.png";

/***/ }),

/***/ "Z31m":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-b6.0b3f448c498b70903671a4bc69efde0d.png";

/***/ }),

/***/ "ZNit":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-f1.2d3e9386d0328114e71184f6946f14b6.png";

/***/ }),

/***/ "ZvN9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-e1.b1cd43842afa4b29b592e9ac499769ca.png";

/***/ }),

/***/ "aDup":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var Z3Em = __webpack_require__("xzou");
var z3emWasm = __webpack_require__("QlVD");
var function_1 = __webpack_require__("NsPZ");
var Wasm_1 = __webpack_require__("4mO9");
var wasm_1 = __webpack_require__("MZjJ");
var ResolveWrapper = (function () {
    function ResolveWrapper(value) {
        this.value = value;
    }
    return ResolveWrapper;
}());
function createZ3Em(z3emOptions) {
    return new Promise(function (resolve, reject) {
        var z3em = Z3Em(tslib_1.__assign({}, z3emOptions, { onRuntimeInitialized: function () {
                resolve(new ResolveWrapper(z3em)); // TODO: unwrapped return freezes browser, WTF?
            } }));
    });
}
// for caching WASM in Chrome: chrome://flags/#enable-webassembly
exports.getZ3 = function_1.memoizeSupplier(function () {
    if (wasm_1.isWasmSupported()) {
        return Wasm_1.Wasm.getCached(z3emWasm).then(function (module) {
            var z3emOptions;
            if (module !== undefined) {
                z3emOptions = {
                    instantiateWasm: function (importObject, receiveInstance) {
                        console.debug("instantiateWasm");
                        WebAssembly.instantiate(module, importObject).then(function (instance) {
                            return receiveInstance(instance, module);
                        });
                        return {}; // instantiateWasm is async
                    }
                };
            }
            else {
                z3emOptions = {
                    locateFile: function () { return z3emWasm; },
                    onReceiveInstance: function (instance, module) {
                        console.debug("onReceiveInstance");
                        Wasm_1.Wasm.cache(z3emWasm, module);
                    }
                };
            }
            console.debug("Z3 arming...");
            return createZ3Em(z3emOptions).then(function (resolveWrapper) {
                var z3em = resolveWrapper.value;
                var z3 = new Z3(z3em);
                console.log("Z3 armed");
                return z3;
            });
        });
    }
    else {
        return Promise.reject(new Error("WebAssembly not supported"));
    }
});
var Z3 = (function () {
    function Z3(z3em) {
        this.z3em = z3em;
        this.errorHandler = this.z3em.addFunction(function (ctx, e) {
            console.error("Z3 (" + ctx + "): " + e);
        }, "vii");
        this.mk_config = this.z3em.cwrap("Z3_mk_config", "number", []);
        this.mk_context = this.z3em.cwrap("Z3_mk_context", "number", ["number"]);
        this.del_config = this.z3em.cwrap("Z3_del_config", null, ["number"]);
        this.del_context = this.z3em.cwrap("Z3_del_context", null, ["number"]);
        this.eval_smtlib2_string = this.z3em.cwrap("Z3_eval_smtlib2_string", "string", ["number", "string"]);
        this.global_param_set = this.z3em.cwrap("Z3_global_param_set", null, ["string", "string"]);
        this.set_error_handler = this.z3em.cwrap("Z3_set_error_handler", null, ["number", "number"]);
    }
    return Z3;
}());
exports.Z3 = Z3;


/***/ }),

/***/ "b/H4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var _ = __webpack_require__("M4fF");
var preact_1 = __webpack_require__("rMlB");
__webpack_require__("99qC");
var Config_1 = __webpack_require__("HZR3");
var Counts_1 = __webpack_require__("7Stf");
var Times_1 = __webpack_require__("vO/K");
var PuzzleOptionsUtils_1 = __webpack_require__("fdQW");
var InputRangeComponent = (function (_super) {
    tslib_1.__extends(InputRangeComponent, _super);
    function InputRangeComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (e) {
            e.preventDefault();
            var value = parseInt(e.target.value);
            _this.props.onChange(value);
        };
        return _this;
    }
    InputRangeComponent.prototype.render = function (props) {
        var listId = props.id + "-list";
        return (preact_1.h("span", { class: "input input-range" },
            preact_1.h("input", tslib_1.__assign({ type: "range" }, props, { value: props.value.toString(), list: listId, onChange: this.onChange, onInput: this.onChange })),
            preact_1.h("output", { for: props.id },
                props.value,
                props.unit),
            preact_1.h("datalist", { id: listId }, _.map(_.range(props.min, props.max + 1, props.step), function (value) {
                return preact_1.h("option", { value: value.toString() });
            }))));
    };
    return InputRangeComponent;
}(preact_1.Component));
var RadioChoiceComponent = (function (_super) {
    tslib_1.__extends(RadioChoiceComponent, _super);
    function RadioChoiceComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioChoiceComponent.prototype.onChange = function (value) {
        var _this = this;
        return function (e) {
            e.preventDefault();
            _this.props.onChange(value);
        };
    };
    RadioChoiceComponent.prototype.render = function (props) {
        var _this = this;
        return (
        // Chrome fieldsets don't flex: https://stackoverflow.com/q/28078681
        preact_1.h("div", { class: "input input-choice" }, _.map(props.choices, function (_a) {
            var value = _a[0], label = _a[1];
            return preact_1.h("span", null,
                preact_1.h("input", { type: "radio", id: props.id + "-" + value, name: props.id, checked: value === props.value, onChange: _this.onChange(value) }),
                preact_1.h("label", { for: props.id + "-" + value }, label));
        })));
    };
    return RadioChoiceComponent;
}(preact_1.Component));
var TopOptionsComponent = (function (_super) {
    tslib_1.__extends(TopOptionsComponent, _super);
    function TopOptionsComponent() {
        var _this = _super.call(this) || this;
        _this.state = {
            topCounts: undefined
        };
        _this.fetchTopCounts();
        return _this;
    }
    TopOptionsComponent.prototype.fetchTopCounts = function () {
        var _this = this;
        Counts_1.Counts.getTopCounts().then(function (topCounts) {
            _this.setState({
                topCounts: topCounts
            });
        });
    };
    TopOptionsComponent.prototype.onClick = function (countsItem) {
        var _this = this;
        var options = {
            rows: countsItem.rows,
            cols: countsItem.cols,
            extraHintsPercent: countsItem.extraHintsPercent,
            difficulty: countsItem.difficulty
        }; // options shouldn't contain Counts fields, breaks IndexedDB query
        return function (e) {
            e.preventDefault();
            _this.props.set(options);
        };
    };
    TopOptionsComponent.prototype.render = function (props, state) {
        var _this = this;
        if (state.topCounts !== undefined && state.topCounts.length > 0) {
            return (preact_1.h("div", { class: "top-options" },
                preact_1.h("hr", null),
                preact_1.h("span", { class: "options-title" }, "Most played:"),
                preact_1.h("ol", null, _.map(_.take(state.topCounts, 5), function (countsItem) {
                    return preact_1.h("li", null,
                        preact_1.h("a", { class: "button", onClick: _this.onClick(countsItem) },
                            PuzzleOptionsUtils_1.formatOptions(countsItem),
                            " ",
                            preact_1.h("small", { className: "small-number" },
                                "(",
                                countsItem.solved + countsItem.solvedCheated + countsItem.over,
                                ")")));
                }))));
        }
        else
            return null;
    };
    return TopOptionsComponent;
}(preact_1.Component));
var OptionsComponent = (function (_super) {
    tslib_1.__extends(OptionsComponent, _super);
    function OptionsComponent(props) {
        var _this = _super.call(this) || this;
        _this.onSubmit = function (e) {
            e.preventDefault();
            _this.props.submit(_this.state.options);
        };
        // No onReset on <form>
        _this.onReset = function (e) {
            e.preventDefault();
            _this.setState({
                options: _.clone(_this.props.defaultOptions),
                hasTimes: false
            });
            _this.fetchHasTimes(_this.state.options);
            Config_1.Config.set({
                options: _this.state.options
            });
        };
        _this.onHighscore = function (e) {
            _this.props.highscore(_this.state.options);
        };
        _this.setOptions = function (options) {
            _this.setState({
                options: _.clone(options),
                hasTimes: false
            });
            _this.fetchHasTimes(_this.state.options);
            Config_1.Config.set({
                options: _this.state.options
            });
        };
        _this.state = {
            options: _.clone(props.options),
            hasTimes: false
        };
        _this.fetchHasTimes(props.options);
        return _this;
    }
    OptionsComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if (!_.eq(this.props, nextProps)) {
            this.setState({
                options: _.clone(nextProps.options),
                hasTimes: false
            });
            this.fetchHasTimes(nextProps.options);
        }
    };
    OptionsComponent.prototype.onChange = function (field) {
        var _this = this;
        return function (value) {
            _this.setState(function (state) {
                return _.merge(state, {
                    options: (_a = {},
                        _a[field] = value // TODO: typecheck this,
                    ,
                        _a),
                    hasTimes: false
                });
                var _a;
            });
            _this.fetchHasTimes(_this.state.options);
            Config_1.Config.set({
                options: _this.state.options
            });
        };
    };
    OptionsComponent.prototype.fetchHasTimes = function (options) {
        var _this = this;
        Times_1.Times.hasTimes(options).then(function (hasTimes) {
            _this.setState({
                hasTimes: hasTimes
            });
        });
    };
    OptionsComponent.prototype.render = function (props, state) {
        return (preact_1.h("form", { class: "options", onSubmit: this.onSubmit },
            preact_1.h("fieldset", { disabled: props.generating },
                preact_1.h("div", { class: "form-group" },
                    preact_1.h("label", { for: "option-rows" }, "Rows"),
                    preact_1.h(InputRangeComponent, { id: "option-rows", min: 2, max: 6, value: state.options.rows, onChange: this.onChange("rows") })),
                preact_1.h("div", { class: "form-group" },
                    preact_1.h("label", { for: "option-cols" }, "Columns"),
                    preact_1.h(InputRangeComponent, { id: "option-cols", min: 2, max: 6, value: state.options.cols, onChange: this.onChange("cols") })),
                preact_1.h("div", { class: "form-group" },
                    preact_1.h("label", { for: "option-extra-hints" }, "Extra hints"),
                    preact_1.h(InputRangeComponent, { id: "option-extra-hints", min: 0, max: 100, step: 20, value: state.options.extraHintsPercent, onChange: this.onChange("extraHintsPercent"), unit: "%" })),
                preact_1.h("div", { class: "form-group" },
                    preact_1.h("label", { for: "option-difficulty" }, "Difficulty"),
                    preact_1.h(RadioChoiceComponent, { id: "option-difficulty", choices: [["normal", "Normal"], ["hard", "Hard"]], value: state.options.difficulty, onChange: this.onChange("difficulty") })),
                preact_1.h("div", { class: "form-group buttons" },
                    preact_1.h("button", { type: "reset", onClick: this.onReset }, "Reset"),
                    preact_1.h("button", { type: "button", disabled: !state.hasTimes, onClick: this.onHighscore }, "High scores"),
                    preact_1.h("button", { class: "button-highlight button-wide", type: "submit", disabled: !props.puzzleGenerator.supports(state.options) }, "Play")),
                preact_1.h(TopOptionsComponent, { set: this.setOptions })),
            props.generating ?
                preact_1.h("div", { class: "loading-overlay" },
                    preact_1.h("div", { class: "lds-dual-ring" })) :
                null));
    };
    return OptionsComponent;
}(preact_1.Component));
exports.OptionsComponent = OptionsComponent;


/***/ }),

/***/ "bWR4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Board = (function () {
    function Board(table, options) {
        if (options === void 0) { options = {
            rows: table.length,
            cols: table[0].length
        }; }
        this.table = table;
        this.options = options;
        this.rows = this.options.rows;
        this.cols = this.options.cols;
        this.variants = this.options.cols;
    }
    Board.prototype.get = function (row, col) {
        return this.table[row][col];
    };
    return Board;
}());
exports.Board = Board;


/***/ }),

/***/ "bwb8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AbstractDistribution = (function () {
    function AbstractDistribution() {
    }
    AbstractDistribution.prototype.scale = function (targetN) {
        var sourceN = this.n;
        return this.mapFreqs(function (freq) { return freq / sourceN * targetN; });
    };
    AbstractDistribution.prototype.scaleTo = function (targetDist) {
        return this.scale(targetDist.n);
    };
    AbstractDistribution.prototype.toPairs = function () {
        return this.map(function (freq, value) { return [value, freq]; });
    };
    AbstractDistribution.prototype.random = function () {
        // https://en.wikipedia.org/wiki/Fitness_proportionate_selection
        // http://www.keithschwarz.com/darts-dice-coins/ - Roulette Wheel Selection (linear)
        var pairs = this.toPairs();
        var cumFreq = Math.random() * this.n;
        for (var i = 0; i < pairs.length; i++) {
            var _a = pairs[i], value = _a[0], freq = _a[1];
            if (cumFreq < freq)
                return value;
            else
                cumFreq -= freq;
        }
        return pairs[pairs.length - 1][0]; // must return in case of bad rounding
    };
    return AbstractDistribution;
}());
exports.AbstractDistribution = AbstractDistribution;


/***/ }),

/***/ "cgSM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-d1.4c6fc5e018efe828eb0a0a8136a8cc76.png";

/***/ }),

/***/ "cnN+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var _ = __webpack_require__("M4fF");
var SingleBoard_1 = __webpack_require__("JMRT");
var ApplyHintsGenerator_1 = __webpack_require__("PvcG");
var DifficultyHintsGenerator_1 = __webpack_require__("GgXB");
var ExtraHintsGenerator_1 = __webpack_require__("6RO1");
var NonApplyHintsGenerator_1 = __webpack_require__("n1vv");
var Z3HintsGenerator_1 = __webpack_require__("Nf2I");
var Puzzle_1 = __webpack_require__("hmo1");
var HintsPuzzleGenerator = (function () {
    function HintsPuzzleGenerator(hintsGenerator) {
        this.hintsGenerator = hintsGenerator;
    }
    HintsPuzzleGenerator.prototype.supports = function (options) {
        return this.hintsGenerator.supports(options);
    };
    HintsPuzzleGenerator.prototype.generate = function (options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var board, start, hints, end;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        board = SingleBoard_1.SingleBoard.random(options);
                        start = _.now();
                        return [4 /*yield*/, this.hintsGenerator.generate(options, board)];
                    case 1:
                        hints = _a.sent();
                        end = _.now();
                        console.log("" + (end - start));
                        return [2 /*return*/, new Puzzle_1.Puzzle(board, hints, options)];
                }
            });
        });
    };
    return HintsPuzzleGenerator;
}());
exports.HintsPuzzleGenerator = HintsPuzzleGenerator;
exports.mainPuzzleGenerator = new HintsPuzzleGenerator(new ExtraHintsGenerator_1.ExtraHintsGenerator(new DifficultyHintsGenerator_1.DifficultyHintsGenerator({
    normal: new ApplyHintsGenerator_1.ApplyHintsGenerator(),
    hard: new NonApplyHintsGenerator_1.NonApplyHintsGenerator(new Z3HintsGenerator_1.Z3HintsGenerator())
})));


/***/ }),

/***/ "d6hy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-d5.ae2144db1de56afe0541c89db7a31463.png";

/***/ }),

/***/ "dSmd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-f6.d614ae0c9d5efd565ca308cd3435188e.png";

/***/ }),

/***/ "dcOB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-e2.bba1807b4ac83d4a610aa663676e1204.png";

/***/ }),

/***/ "etg9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var preact_1 = __webpack_require__("rMlB");
var time_1 = __webpack_require__("5AqA");
var TimerComponent = (function (_super) {
    tslib_1.__extends(TimerComponent, _super);
    function TimerComponent(props) {
        var _this = _super.call(this) || this;
        _this.interval = null;
        _this.state = {
            time: props.timer.getTotalTime()
        };
        return _this;
    }
    TimerComponent.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({
            time: nextProps.timer.getTotalTime()
        });
        this.setTimer();
    };
    TimerComponent.prototype.componentDidMount = function () {
        this.setTimer();
    };
    TimerComponent.prototype.componentWillUnmount = function () {
        this.clearTimer();
    };
    TimerComponent.prototype.clearTimer = function () {
        if (this.interval !== null)
            clearInterval(this.interval);
    };
    TimerComponent.prototype.setTimer = function () {
        var _this = this;
        this.clearTimer();
        setTimeout(function () {
            _this.interval = setInterval(function () {
                _this.setState({
                    time: _this.props.timer.getTotalTime()
                });
            }, 1000);
        }, 0); // HACK: give enough delay to make interval fall between seconds and avoid second skipping
    };
    TimerComponent.prototype.render = function (props, state) {
        return (preact_1.h("div", { class: "timer" }, time_1.formatDuration(state.time)));
    };
    return TimerComponent;
}(preact_1.Component));
exports.TimerComponent = TimerComponent;


/***/ }),

/***/ "euc6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LongTouchContextMenuHandler = (function () {
    function LongTouchContextMenuHandler(callback) {
        var _this = this;
        this.callback = callback;
        // iOS long touch workaround
        // https://stackoverflow.com/a/33778163
        // https://jsfiddle.net/gianlucaguarini/56Szw/
        // https://stackoverflow.com/a/33303261
        this.onTouchStart = function (e) {
            // console.debug("touchstart");
            LongTouchContextMenuHandler.touching = true;
            _this.timeout = setTimeout(function () {
                console.log("longtouch");
                _this.callback();
            }, LongTouchContextMenuHandler.longTouchTime);
        };
        this.onTouchMove = function (e) {
            // console.debug("touchmove");
            clearTimeout(_this.timeout);
        };
        this.onTouchEnd = function (e) {
            // console.debug("touchend");
            LongTouchContextMenuHandler.touching = false;
            clearTimeout(_this.timeout);
        };
        this.onTouchCancel = function (e) {
            // console.debug("touchcancel");
            LongTouchContextMenuHandler.touching = false;
            clearTimeout(_this.timeout);
        };
        this.onContextMenu = function (e) {
            e.preventDefault();
            if (!LongTouchContextMenuHandler.touching)
                _this.callback();
        };
    }
    LongTouchContextMenuHandler.touching = false;
    LongTouchContextMenuHandler.longTouchTime = 500;
    return LongTouchContextMenuHandler;
}());
exports.LongTouchContextMenuHandler = LongTouchContextMenuHandler;


/***/ }),

/***/ "fZOX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-b5.39e97e63457f6a5ef329ce7a1f329d47.png";

/***/ }),

/***/ "fdQW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function formatOptions(options) {
    var difficultyText = options.difficulty === "hard" ? "hard " : "";
    var extraHintsText = options.extraHintsPercent > 0 ? " with " + options.extraHintsPercent + "% extra hints" : "";
    return options.rows + "\u00D7" + options.cols + " " + difficultyText + "puzzle" + extraHintsText;
}
exports.formatOptions = formatOptions;


/***/ }),

/***/ "gBE2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-c2.488e286fbc404fc350cc0e4def122c83.png";

/***/ }),

/***/ "gVWB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-f3.0070d3861e60350f291165d89028d7d1.png";

/***/ }),

/***/ "gYeE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PairsDistribution_1 = __webpack_require__("Seff");
var AdjacentHint_1 = __webpack_require__("2+Yo");
var BetweenHint_1 = __webpack_require__("DAXx");
var DirectionHint_1 = __webpack_require__("X9r5");
var OpenHint_1 = __webpack_require__("HwaM");
var SameColumnHint_1 = __webpack_require__("JIJM");
var RandomHintFactory = (function () {
    function RandomHintFactory() {
        // hint frequency distribution from original einstein 2.0
        this.defaultDist = new PairsDistribution_1.PairsDistribution([
            [new AdjacentHint_1.AdjacentHintFactory(), 4],
            [new OpenHint_1.OpenHintFactory(), 1],
            [new SameColumnHint_1.SameColumnHintFactory(), 2],
            [new DirectionHint_1.DirectionHintFactory(), 4],
            [new BetweenHint_1.BetweenHintFactory(), 3]
        ]);
    }
    RandomHintFactory.prototype.supports = function (options) {
        return this.defaultDist.filter(function (freq, value) { return value.supports(options); }).classes > 0;
    };
    RandomHintFactory.prototype.random = function (board) {
        var dist = this.defaultDist.filter(function (freq, value) { return value.supports(board.options); });
        var hintFactory = dist.random();
        return hintFactory.random(board);
    };
    return RandomHintFactory;
}());
exports.RandomHintFactory = RandomHintFactory;


/***/ }),

/***/ "hFVX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-d6.83aaeda6a3e029931af97f484755879f.png";

/***/ }),

/***/ "hli+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-e5.b1fdec84ea77accaea3f9a52908d69f3.png";

/***/ }),

/***/ "hmo1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__("M4fF");
var MultiBoard_1 = __webpack_require__("CBd9");
var PuzzleGenerator_1 = __webpack_require__("cnN+");
var Puzzle = (function () {
    function Puzzle(singleBoard, hints, options) {
        this.singleBoard = singleBoard;
        this.hints = hints;
        this.options = options;
        this.multiBoard = MultiBoard_1.MultiBoard.full(options);
        this.multiBoard.applyHints(_.filter(hints, function (hint) { return hint.getType() === 0 /* Start */; }));
    }
    Puzzle.prototype.isSolved = function () {
        return this.multiBoard.isSolved(this.singleBoard);
    };
    Puzzle.prototype.isOver = function () {
        return !this.multiBoard.contains(this.singleBoard);
    };
    Puzzle.prototype.applySingleHint = function () {
        return this.multiBoard.applySingleHint(_.filter(this.hints, function (hint) { return hint.getType() !== 0 /* Start */; }));
    };
    Puzzle.prototype.canApplySingleHint = function () {
        var tmpPuzzle = _.cloneDeep(this);
        return tmpPuzzle.applySingleHint();
    };
    Puzzle.generate = function (options) {
        return PuzzleGenerator_1.mainPuzzleGenerator.generate(options); // TODO: remove because usages should check supports before
    };
    return Puzzle;
}());
exports.Puzzle = Puzzle;


/***/ }),

/***/ "iXl1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-d4.465fbcbda569f002956eff6dbc525fba.png";

/***/ }),

/***/ "kCQN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./rain.0d05874e0f2cdd3a51985dd895f01fd0.png";

/***/ }),

/***/ "kbZK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-c1.857515213e12574db6ea3b7694015dd8.png";

/***/ }),

/***/ "lgdU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-e6.f63290d00dca1fb50b97a7749bbc6fdc.png";

/***/ }),

/***/ "mGEC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-c4.83eef6ef77656276b988cffc6dd1b2dd.png";

/***/ }),

/***/ "mPGt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-b6.29228909139aed0e29c1e0d248fdc8b1.png";

/***/ }),

/***/ "mcFw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-c3.8ecb4d1c7b95cff1b3f7a4e3e0342ad0.png";

/***/ }),

/***/ "n1vv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var HintsGenerator_1 = __webpack_require__("S+P+");
var NonApplyHintsGenerator = (function (_super) {
    tslib_1.__extends(NonApplyHintsGenerator, _super);
    function NonApplyHintsGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NonApplyHintsGenerator.prototype.supports = function (options) {
        return options.cols > 2 && _super.prototype.supports.call(this, options);
    };
    NonApplyHintsGenerator.prototype.generate = function (options, board) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var hints, i;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        i = 0;
                        _a.label = 1;
                    case 1: return [4 /*yield*/, this.delegate.generate(options, board)];
                    case 2:
                        hints = _a.sent();
                        i++;
                        _a.label = 3;
                    case 3:
                        if (board.isSolvable(hints)) return [3 /*break*/, 1];
                        _a.label = 4;
                    case 4:
                        console.log(i + " tries to non-apply");
                        return [2 /*return*/, hints];
                }
            });
        });
    };
    return NonApplyHintsGenerator;
}(HintsGenerator_1.DelegateHintsGenerator));
exports.NonApplyHintsGenerator = NonApplyHintsGenerator;


/***/ }),

/***/ "nVYH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-a2.e58c4d7d4ca282f01f1842de56fcc204.png";

/***/ }),

/***/ "oD70":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-d2.9a9e2546ef2de2aed7b9cafca1e574a4.png";

/***/ }),

/***/ "oJmq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-c6.b70b863014dd77f1444a4f5dcfaf937d.png";

/***/ }),

/***/ "oXIE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-c2.c8ea002cb52b8a2bb2391a8a599a1be2.png";

/***/ }),

/***/ "ouBu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var preact_1 = __webpack_require__("rMlB");
__webpack_require__("xToJ");
var BirthdayComponent = (function (_super) {
    tslib_1.__extends(BirthdayComponent, _super);
    function BirthdayComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BirthdayComponent.prototype.render = function (props) {
        var now = new Date();
        if (now.getMonth() + 1 == props.month && now.getDate() == props.day) {
            return (preact_1.h("div", { class: "birthday" },
                preact_1.h("p", null,
                    "Happy birthday, ",
                    props.name,
                    "!")));
        }
        else
            return null;
    };
    return BirthdayComponent;
}(preact_1.Component));
exports.BirthdayComponent = BirthdayComponent;


/***/ }),

/***/ "pJA7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pqg3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-a6.b74ac4a06b9b99cdebadc188e6f2eba7.png";

/***/ }),

/***/ "q9gS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-d6.3707649a76849867b0067b33cee2f45a.png";

/***/ }),

/***/ "qMEF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = __webpack_require__("rMlB");
var AppComponent_1 = __webpack_require__("SLpm");
var OfflinePluginRuntime = __webpack_require__("t8iB");
console.log("-------");
OfflinePluginRuntime.install();
// import "preact/devtools";
preact_1.render(preact_1.h(AppComponent_1.AppComponent, null), document.body);
/*var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
alert(width);*/
/*
let listener = new VisibilityChangeListener(visible => console.log(`Visibility ${visible} ${document.visibilityState}`));
listener.add();*/


/***/ }),

/***/ "qpPT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-a1.7ec6461d1c92b8cd2af53465e9b35cfc.png";

/***/ }),

/***/ "qwlA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/hint-tile.fef2ac154678271b433d05cac0e1e766.png";

/***/ }),

/***/ "romA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-b4.5539a0f576453510700b7e1ac8ac62c2.png";

/***/ }),

/***/ "rxGk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-c5.649a708fdfe3823d8ad66395bf760461.png";

/***/ }),

/***/ "t+UZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-f5.23ad85abc671b650c4fab087327177b8.png";

/***/ }),

/***/ "uLm8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-e2.2a6f0dc9158e2248beb5da27abf58387.png";

/***/ }),

/***/ "uVvn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-a5.a7e023b76efb421fce243698ec5c1172.png";

/***/ }),

/***/ "uyRy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vO/K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var _ = __webpack_require__("M4fF");
var db_1 = __webpack_require__("ATbC");
var Times;
(function (Times) {
    function addItem(timesItem) {
        return db_1.db.times.add(timesItem);
    }
    Times.addItem = addItem;
    function add(options, time, name) {
        var timesItem = tslib_1.__assign({}, options, { time: time, date: new Date(), name: name });
        return addItem(timesItem);
    }
    Times.add = add;
    function getSortedTimes(options) {
        return db_1.db.times.where(tslib_1.__assign({}, options)).sortBy("time");
    }
    Times.getSortedTimes = getSortedTimes;
    function getTop10(options) {
        return getSortedTimes(options).then(function (timesItems) {
            return _.take(timesItems, 10);
        });
    }
    Times.getTop10 = getTop10;
    function isInTop10(options, time) {
        return getSortedTimes(options).then(function (timesItems) {
            if (timesItems.length < 10 || time < timesItems[10 - 1].time)
                return _.sortedIndexBy(timesItems.slice(0, 10), { time: time }, function (timesItem) { return timesItem.time; });
            else
                return false;
        });
    }
    Times.isInTop10 = isInTop10;
    function hasTimes(options) {
        return db_1.db.times.where(tslib_1.__assign({}, options)).count(function (count) { return count > 0; });
    }
    Times.hasTimes = hasTimes;
})(Times = exports.Times || (exports.Times = {}));


/***/ }),

/***/ "voAe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-f1.cf4eb2f72546034b67c7e387426aab1f.png";

/***/ }),

/***/ "w35o":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-b2.f088bd5349ae94f3aecf2256a2a41f9a.png";

/***/ }),

/***/ "x5BK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-a3.b5693ec5ce8e44c2ab79da7d22e419c0.png";

/***/ }),

/***/ "xDob":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-d2.f554d768eed7fb9c2ac1361d80a08e82.png";

/***/ }),

/***/ "xFS2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-f2.1214cc29cc865a50e028b884cf34173d.png";

/***/ }),

/***/ "xToJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yFfv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-f4.43276b459501e836f1928103bcbdc92c.png";

/***/ }),

/***/ "yFiT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var VisibilityChangeListener = (function () {
    function VisibilityChangeListener(callback) {
        var _this = this;
        this.callback = callback;
        this.visible = true;
        this.focused = function () {
            // console.debug(`focused ${document.visibilityState}`);
            if (!_this.visible)
                _this.callback(_this.visible = true);
        };
        this.unfocused = function () {
            // console.debug(`unfocused ${document.visibilityState}`);
            if (_this.visible)
                _this.callback(_this.visible = false);
        };
    }
    VisibilityChangeListener.prototype.add = function () {
        // https://stackoverflow.com/a/38710376
        var _this = this;
        // Standards:
        if ('hidden' in document) {
            document.addEventListener('visibilitychange', function () { (document.hidden ? _this.unfocused : _this.focused)(); });
        }
        if ('mozHidden' in document) {
            document.addEventListener('mozvisibilitychange', function () { (document.mozHidden ? _this.unfocused : _this.focused)(); });
        }
        if ('webkitHidden' in document) {
            document.addEventListener('webkitvisibilitychange', function () { (document.webkitHidden ? _this.unfocused : _this.focused)(); });
        }
        if ('msHidden' in document) {
            document.addEventListener('msvisibilitychange', function () { (document.msHidden ? _this.unfocused : _this.focused)(); });
        }
        // IE 9 and lower:
        if ('onfocusin' in document) {
            document.onfocusin = this.focused;
            document.onfocusout = this.unfocused;
        }
        // All others:
        window.onpageshow = window.onfocus = this.focused;
        window.onpagehide = window.onblur = this.unfocused;
        // TODO: initial visibility check like https://stackoverflow.com/a/1060034
    };
    VisibilityChangeListener.prototype.remove = function () {
        // TODO: remove listeners
    };
    return VisibilityChangeListener;
}());
exports.VisibilityChangeListener = VisibilityChangeListener;


/***/ }),

/***/ "yNUn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/small/small-f4.fa8fa0e7c09873297312ed5082eac413.png";

/***/ }),

/***/ "ytF8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-a4.30bcbdd3b26849030d9f7756c19d6a98.png";

/***/ }),

/***/ "zU+P":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons/original/large/large-f2.ebac4e572194ab532410773494ed9c4e.png";

/***/ }),

/***/ "ziB5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var classNames = __webpack_require__("HW6M");
var _ = __webpack_require__("M4fF");
var preact_1 = __webpack_require__("rMlB");
var LongTouchContextMenuHandler_1 = __webpack_require__("euc6");
var IconComponents_1 = __webpack_require__("NsAh");
__webpack_require__("pJA7");
var SingleCellComponent = (function (_super) {
    tslib_1.__extends(SingleCellComponent, _super);
    function SingleCellComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SingleCellComponent.prototype.render = function (props) {
        return (preact_1.h("div", { class: "cell-single" },
            preact_1.h(IconComponents_1.LargeVariantIconComponent, { row: props.row, variant: props.variant })));
    };
    return SingleCellComponent;
}(preact_1.Component));
var VariantVariantMultiCellComponent = (function (_super) {
    tslib_1.__extends(VariantVariantMultiCellComponent, _super);
    function VariantVariantMultiCellComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.contextMenuHandler = new LongTouchContextMenuHandler_1.LongTouchContextMenuHandler(function () { return _this.remove(); });
        _this.onClick = function (e) {
            _this.set();
        };
        return _this;
    }
    VariantVariantMultiCellComponent.prototype.set = function () {
        this.props.board.set(this.props.row, this.props.col, this.props.variant);
        this.props.refresh();
    };
    VariantVariantMultiCellComponent.prototype.remove = function () {
        this.props.board.remove(this.props.row, this.props.col, this.props.variant);
        this.props.refresh();
    };
    VariantVariantMultiCellComponent.prototype.render = function (props) {
        return (preact_1.h("div", tslib_1.__assign({ class: "cell-multi-variant", onClick: this.onClick }, this.contextMenuHandler),
            preact_1.h(IconComponents_1.SmallVariantIconComponent, { row: props.row, variant: props.variant })));
    };
    return VariantVariantMultiCellComponent;
}(preact_1.Component));
var EmptyVariantMultiCellComponent = (function (_super) {
    tslib_1.__extends(EmptyVariantMultiCellComponent, _super);
    function EmptyVariantMultiCellComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmptyVariantMultiCellComponent.prototype.render = function (props) {
        return (preact_1.h("div", { class: "cell-multi-empty" }));
    };
    return EmptyVariantMultiCellComponent;
}(preact_1.Component));
var VariantMultiCellComponent = (function (_super) {
    tslib_1.__extends(VariantMultiCellComponent, _super);
    function VariantMultiCellComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VariantMultiCellComponent.prototype.render = function (props) {
        if (props.variant < props.board.variants &&
            props.board.isPossible(props.row, props.col, props.variant))
            return preact_1.h(VariantVariantMultiCellComponent, tslib_1.__assign({}, props));
        else
            return preact_1.h(EmptyVariantMultiCellComponent, tslib_1.__assign({}, props));
    };
    return VariantMultiCellComponent;
}(preact_1.Component));
var MultiCellComponent = (function (_super) {
    tslib_1.__extends(MultiCellComponent, _super);
    function MultiCellComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultiCellComponent.prototype.render = function (props) {
        var variantCols = Math.ceil(Math.sqrt(props.board.variants));
        var variantRows = Math.ceil(props.board.variants / variantCols);
        return (preact_1.h("table", { class: "cell-multi" }, _.times(variantRows, function (variantRow) {
            return preact_1.h("tr", null, _.times(variantCols, function (variantCol) {
                return preact_1.h("td", null,
                    preact_1.h(VariantMultiCellComponent, tslib_1.__assign({}, props, { variant: variantRow * variantCols + variantCol })));
            }));
        })));
    };
    return MultiCellComponent;
}(preact_1.Component));
var CellComponent = (function (_super) {
    tslib_1.__extends(CellComponent, _super);
    function CellComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onContextMenu = function (e) {
            e.preventDefault();
        };
        return _this;
    }
    CellComponent.prototype.render = function (props) {
        if (props.showBoard) {
            var correct = props.board.isSingle(props.row, props.col) && props.board.getSingle(props.row, props.col) == props.showBoard.get(props.row, props.col);
            return (preact_1.h("td", { class: classNames({
                    "cell-correct": correct,
                    "cell-incorrect": !correct
                }) },
                preact_1.h("div", { class: "cell", onContextMenu: this.onContextMenu },
                    preact_1.h(SingleCellComponent, tslib_1.__assign({}, props, { variant: props.showBoard.get(props.row, props.col) })))));
        }
        else {
            return (preact_1.h("td", null,
                preact_1.h("div", { class: "cell", onContextMenu: this.onContextMenu }, props.board.isSingle(props.row, props.col) ?
                    preact_1.h(SingleCellComponent, tslib_1.__assign({}, props, { variant: props.board.getSingle(props.row, props.col) })) :
                    preact_1.h(MultiCellComponent, tslib_1.__assign({}, props)))));
        }
    };
    return CellComponent;
}(preact_1.Component));
var RowComponent = (function (_super) {
    tslib_1.__extends(RowComponent, _super);
    function RowComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.refresh = function () {
            _this.forceUpdate();
            _this.props.refresh();
        };
        return _this;
    }
    RowComponent.prototype.render = function (props) {
        var _this = this;
        return (preact_1.h("tr", null, _.times(props.board.cols, function (col) {
            return preact_1.h(CellComponent, tslib_1.__assign({}, props, { col: col, refresh: _this.refresh }));
        })));
    };
    return RowComponent;
}(preact_1.Component));
var MultiBoardComponent = (function (_super) {
    tslib_1.__extends(MultiBoardComponent, _super);
    function MultiBoardComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultiBoardComponent.prototype.render = function (props) {
        var board = props.board;
        var data = {
            "data-rows": board.rows,
            "data-cols": board.cols
        };
        return (preact_1.h("div", tslib_1.__assign({ class: "multiboard-outer" }, data),
            preact_1.h("table", tslib_1.__assign({ class: "multiboard" }, data), _.times(board.rows, function (row) {
                return preact_1.h(RowComponent, tslib_1.__assign({}, props, { row: row }));
            }))));
    };
    return MultiBoardComponent;
}(preact_1.Component));
exports.MultiBoardComponent = MultiBoardComponent;


/***/ })

},["qMEF"]);


// WEBPACK FOOTER //
// app.832be36709f42fc335e79aa1ab68e92f.js